import React, { useContext, useState } from 'react';
import { HeaderHeightContext } from '../../App';

const idc = [
  {
    title: '제1장 총칙',
    sub: [
      {
        title: '제 1조 (목적)',
        content:
          '본 약관은 ㈜디엔에이클라우드 (이하 “회사”)가 제공하는 IDC(internet data center) 관련 제반 서비스의 이용에 대하여 “회사”와 회원(본 약관에 동의하고 회원등록을 완료한 서비스 이용자를 의미합니다. 이하 “회원”)과의 권리•의무 및 기타 필요한 사항을 규정함을 목적으로 합니다. ',
      },
      {
        title: '제2조 (용어의 정의)',
        content:
          '본 약관에서 사용하는 용어의 정의는 다음과 같습니다.\n' +
          '1. “코로케이션 서비스”(Colocation Service)라 함은 회원이 자신의 서버를 회사의 IDC 내에 임치하고, 회사의 인터넷 기간망에 자신의 서버 및 장비를 연결하여 제공받는 초고속인터넷 서비스를 의미합니다.\n' +
          '2. “맞춤형 IT설비 서비스”라 함은 회사가 “코로케이션 서비스” 제공에 있어 회원의 요청에 의한 맞춤형 IDC인프라를 제공하는 서비스를 의미합니다.\n' +
          '3. “호스팅 서비스”(Hosting Service)라 함은 회사가 회원에게 서버 혹은 네트워크를 임대하고 인터넷을 이용한 서비스를 할 수 있도록 하며, 이를 관리하는 서비스를 의미합니다. 전1호와 본호를 통칭하여 “서비스”라 합니다.\n' +
          '4. “부가 서비스”라 함은 회원이 서비스를 이용하여 서버의 운영을 원활하게 하기 위하여 회사에서 기본으로 제공 서비스 이외의 제공되는 서비스를 의미합니다.\n' +
          '5. “상면”또는 “랙”(Rack)이라 함은 회원의 서버 등의 장비를 보관하는 공간을 의미하며, 단위로는 U(Unit), Rack(1/8, 1/4, 1/2, full), 평 (400/121 m2 )을 사용합니다.\n' +
          '6. “트래픽”(파일 전송량)이라 함은 클라이언트 프로그램이 일정 시간 동안 서버로 데이터를 보내거나(Upload) 내려 받은(Download) 데이터를 의미하며, 단위로는 Mbyte/sec, Gbyte/sec 를 사용합니다.\n' +
          '7. “대역”(Bandwidth)이라 함은 클라이언트 프로그램이 물리적인 회선을 이용할 때 데이터를 주고받기 위하여 실제로 점유하는 크기를 의미하며, 이의 측정은 사용한 트래픽 량을 일정 시간 단위로 이동 평균 그래프를 그리는 경우(Multi Router Traffic Grapher: MRTG) 의 폭으로 하며, 단위로는 Mbit/sec, Gbit/sec 를 사용합니다.\n' +
          '8. “이용계약”이라 함은 회사가 제공하는 서비스 이용과 관련하여 회사와 이용자 간에 체결하는 계약을 의미합니다.\n' +
          '9. “서비스 이용요금”이라 함은 본 서비스 계약을 수행하기 위하여 회원에게 청구하는 회사의 제반 서비스 비용으로, 계약되어진 정규성 경비와 추가적인 트래픽 이용료, 서버의 설치, 기술지원 등 계약서 내에 규정되어 있지는 않으나 쌍방 합의에 의하여 수행되어진 추가적인 서비스 업무에 대한 실비기준의 비정규성 경비를 의미합니다.\n' +
          '10. “ID”(아이디)라 함은 회원의 식별과 서비스 이용을 위하여 회원이 정하고 회사가 승인하는 문자와 숫자의 조합을 의미합니다.\n' +
          '11. “비밀번호”라 함은 회원이 부여 받은 ID와 일치하는 회원임을 확인하고 비밀보호를 위해 회원 자신이 정한 문자 또는 숫자의 조합을 의미합니다.',
      },
      {
        title: '제3조 (약관의 게시와 개정)',
        content:
          '1. 회사는 본 약관의 내용을 회원이 쉽게 알 수 있도록 서비스 초기 화면에 게시합니다.\n' +
          '2. 회사는 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제에 관한 법률, 소비자기본법 등 관련법을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.\n' +
          '3. 회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 기존약관과 함께 그 적용일자 7일 전부터 적용일자 전일까지 공지합니다. 다만, 회원에게 불리한 약관의 개정의 경우에는 시행일로부터 30일 전 서비스 홈페이지에 공지하거나 회원이 회원이용신청 시 등록한 e-mail로 전송하는 방법으로 회원에게 통지합니다.\n' +
          '4. 회사가 전항에 따라 회원에게 개정약관을 공지 또는 통지하면서 회원에게 약관시행일까지 의사표시를 하지 않으면 승인한 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 개정약관에 동의한 것으로 봅니다.\n' +
          '5. 회원이 개정약관의 적용에 동의하지 않는 경우 회사는 개정약관의 내용을 적용할 수 없으며, 이 경우 회원은 이용계약을 해지 할 수 있습니다.\n',
      },
    ],
  },
  {
    title: '제2장 이용계약 체결 및 관리',
    sub: [
      {
        title: '제4조 (이용계약 체결)',
        content:
          '1. 회사가 제공하는 서비스를 이용하고자 하는 자가 본 약관을 읽고 동의를 한 다음 회사가 제시하는 양식과 절차에 따라 이용신청을 한 내용에 대해 회사가 승낙함으로써 회사와 서비스 이용자 간 이용계약이 체결됩니다. 단, 이용신청에 별도의 자료제출이 요청되는 경우에는 예외로 합니다.\n' +
          '2. 회사는 다음 각호에 해당하는 신청에 대해서는 승낙을 하지 않거나 사후에 이용계약을 해제 또는 해지 할 수 있습니다.\n' +
          '① 허위의 정보를 기재하거나 허위서류를 첨부하여 이용신청을 하는 경우\n' +
          '② 회사가 제시하는 회원 이용신청 절차를 완료하지 않거나 본인확인이 불가능한 경우\n' +
          '③ 이용신청을 하고 회사가 별도로 규정하는 기간 내에 회사가 별도로 요구하는 자료제출을 하지 않는 경우\n' +
          '④ 회사의 서비스 제공을 저해하거나 타 회원의 서비스 이용에 지장을 줄 것으로 예상되는 경우\n' +
          '⑤ 제3자의 신용카드, 유/무선 전화, 은행 계좌 등을 무단으로 이용 또는 도용하여 서비스 이용요금을 결제하는 경우\n' +
          '⑥ 제34조에 의하여 회사로부터 계약해지를 당한 이후 1년이 경과하지 않은 경우\n' +
          '⑦ 관련법령 등을 기준으로 하여 명백하게 사회질서 및 미풍양속에 반하는 위법행위를 할 목적으로 이용신청을 하는 경우\n' +
          '⑧ 기타 회원의 자격을 부여하기에 곤란한 사유가 있는 경우\n' +
          '3. 회사는 다음 각호에 해당하는 신청에 대해서는 승낙을 지연할 수 있습니다.\n' +
          '① 회사의 설비에 여유가 없거나 기술적 장애가 있는 경우\n' +
          '② 서비스 상의 장애 또는 서비스 이용요금 결제수단의 장애가 발생한 경우\n' +
          '③ 기타 회사가 재정적, 기술적으로 필요하다고 인정하는 경우',
      },
      {
        title: '제5조 (회원의 ID등의 관리 의무)',
        content: `1. 회원은 서비스 이용을 위한 ID 및 비밀번호의 관리에 대한 책임, 본인 ID의 제3자에 의한 부정사용 등 회원의 고의•과실로 인해 발생하는 모든 불이익에 대한 책임을 부담합니다.
2. 회원은 ID, 비밀번호 등을 도난 당하거나 제3자가 사용하고 있음을 인지한 경우에는 즉시 비밀번호를 수정하는 등의 조치를 취하여야 하며, 이를 회사에 통보하여 회사의 안내를 따라야 합니다.


제6조 (회원정보의 변경)
회원은 이용신청 시 기재한 사항이 변경되었을 경우 홈페이지 기재의 전화 및 e-mail로 회원정보의 수정을 요청하여야 하며, 변경하지 않음으로써 발생한 불이익에 대하여 회사는 책임을 지지 않습니다.`,
      },
      {
        title: '제7조 (개인정보 수집)',
        content: `1. 회사는 적법하고 공정한 수단에 의하여 이용계약의 성립 및 이행에 필요한 최소한의 개인정보를 수집합니다.
2. 회사는 개인정보의 수집 시 관련법규에 따라 개인정보처리방침에 그 수집범위 및 목적을 사전 고지합니다.`,
      },
      {
        title: '제8조 (개인정보보호의무)',
        content: `회사는 정보통신망법 등 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및 회사의 개인정보처리방침이 적용됩니다. `,
      },
      {
        title: '제9조 (불만처리)',
        content: `1. 회사는 개인정보와 관련하여 회원의 의견을 수렴하고 불만을 처리하기 위한 절차를 마련하여야 합니다.
2. 회사는 전화, 전자우편 등을 통하여 회원의 불만사항을 접수, 처리 하여야 합니다.`,
      },
      {
        title: '제10조 (회사의 의무)',
        content: `1. 회사는 관련법과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 서비스를 제공하기 위하여 노력합니다.
2. 회사는 서비스 운영에 지장이 되는 장애가 발생했을 경우 이를 즉시 수리 또는 복구해야 하며, 안정적인 서비스 운영을 위해 최선을 다해야 합니다.
3. 회사는 회원의 개인정보보호를 위하여 보안시스템을 갖추어야 하며 개인정보처리방침을 공시하고 준수합니다.
4. 회사는 회원이 스팸메일 전송 등 불법행위를 한 사실을 확인한 경우, 한국인터넷진흥원, 경찰청 등 관계기관에 관련 자료를 첨부하여 신고할 수 있습니다.
5. 회사는 회원 중 고정 IP를 사용하는 개인 및 관리자 정보를 한국인터넷진흥원 등 인터넷주소관리기관에 최소한의 범위 내에서 제공할 수 있습니다.
6. 회사는 회원으로부터 제기되는 의견이나 불만이 정당하다고 인정되는 경우에는 이를 즉시 처리합니다. 회원이 이용신청 시 기입한 전화나 e-mail로 처리과정 및 결과를 통보할 수 있습니다.`,
      },
      {
        title: '제11조 (회원의 의무)',
        content: `1. 회원은 회사가 정한 서비스 이용요금을 지정된 일자에 납입할 의무가 있습니다.
2. 회원은 회사가 제공하는 서비스를 이용함에 있어 다음 각 호에 해당하는 행위를 하여서는 안됩니다.
① 이용신청이나 변경 시 타인의 정보 또는 허위내용을 등록하는 행위
② 다른 회원의 ID 및 비밀번호를 도용하는 행위
③ 회사 및 타인의 명예를 손상시키거나 업무를 방해하는 행위
④ 스팸메일을 전송하는 행위
⑤ 음란 또는 폭력적 메세지, 사행행위 유도, 청소년보호법에서 규정하는 청소년유해매체물, 기타 공서양속에 반하는 정보를 전송, 도달, 유포하는 행위
3. 회원은 자신의 웹사이트를 통하여 제공하는 정보의 저작권에 대하여 책임을 부담해야 합니다.
4. 회원은 자신이 운영 중인 서버가 인가 받지 않은 침입자로부터 안전하게 보호받을 수 있도록 시스템 운영과 관련한 정기적인 보안 업데이트를 하여야 하며, 별도로 시스템 보안 서비스와 관련한 계약을 회사와 체결한 경우를 제외하고는 발생한 보안 사고에 대하여 회사는 책임을 지지 아니합니다.
5. 회원은 자신이 운영 중인 서비스의 데이터 등에 대해 별도로 저장할 의무가 있으며 외부 침입 등으로 인한 정보의 유출, 누락 또는 자료의 손실에 대해 회사는 책임을 지지 않습니다. 단, 회사가 해당 자료를 백업하여 별도로 보관 중인 경우에는 복구 시 도움을 줄 수 있으며, 백업자료가 없는 경우에는 회사는 책임을 지지 않습니다.
6. 회원은 회사로부터 제공받은 설비, 계정 및 소프트웨어 등을 망실 또는 훼손하거나 장애를 초래한 경우에는 그 보충, 수선 또는 기타 공사에 소요되는 비용을 부담하여야 합니다.
7. 회원은 관련법 및 본 약관의 규정을 비롯하여 회사가 통지하는 사항 등을 준수하여야 합니다.`,
      },
    ],
  },
  {
    title: '제3장 서비스의 이용',
    sub: [
      {
        title: '제12조 (서비스의 이용개시)',
        content: `1. 회사는 회원이 이용신청서에 기재한 서비스 개통 희망일에 맞추어 서비스를 개통합니다. 다만, 회사의 업무일정과 서버 등의 장비 및 설비 현황에 따라 서비스 개통 예정일이 변경될 수 있습니다.
2. 회사는 업무상 또는 기술상의 장애로 인하여 서비스를 개시하지 못하는 경우에는 회원에게 이를 통지합니다.
3. 회원은 서비스 개통 예정일을 변경 또는 연기 하고자 하는 경우 개통 예정일로부터 최소 3일 전 회사에 통지하여야 하며, 변경 또는 연기된 개통 예정일이 최초 개통 예정일로부터 3일을 초과하는 경우, 회사는 자신의 판단으로 회원과 최초 협의한 장비 설치장소를 변경할 수 있습니다.`,
      },
      {
        title: '제13조 (서버환경 지원 및 서비스 이전)',
        content: `1. 회사는 회원이 정상적으로 서비스를 이용할 수 있도록 최적의 서버환경을 지원해야 하며, 회원이 특별한 서버환경을 요청하는 경우에는 별도로 합의하여야 합니다.
2. 회원이 서비스를 타사로 이전하는 경우 네임서버의 캐시(cache) 등으로 인하여 회사의 과실 없이 접속이 1~2일 정도 중단되더라도 이는 인터넷 환경의 특성이므로 회사는 이에 대한 책임을 지지 아니 합니다. 또한 이전과 관련하여 기존에 사용하는 파일의 이전과 권한 설정작업은 회원이 직접 하여야 합니다.`,
      },
      {
        title: '제14조 (서비스의 제공)',
        content: `1. 회사는 회원에게 아래와 같은 서비스를 제공합니다.
① 코로케이션 서비스
② 호스팅 서비스
③ 보안 서비스
④ 서버세팅 서비스
⑤ 백업 서비스
⑥ 기타 회사가 추가 개발하거나 다른 회사와의 제휴계약 등을 통해 회원에게 제공할 일체의 서비스
2. 제1항의 각 서비스 및 제휴 서비스의 내용은 변경 될 수 있으며, 이 경우 회사는 서비스 홈페이지에 공지하거나 회원이 이용신청 시 등록한 e-mail로 회원에게 통지 합니다.
3. 서비스는 연중무휴 1일 24시간 제공함을 원칙으로 합니다.`,
      },
      {
        title: '제15조 (코로케이션 서비스의 이용)',
        content: `1. 회원은 자신의 서버 등의 장비에 대한 충분한 테스트 기간과 안정성을 확인한 후 회사가 지정하는 회사 건물 내부의 일정한 장소에 설치합니다.
2. 회원은 회사에 장비의 설치를 요청할 수 있으며, 이 경우 회사는 회사의 내부 네트워크에 회원의 장비를 연결하여 정상적인 작동이 가능하도록 처리합니다. 이에 대한 비용은 최초 장비 설치 1회에 대해서만 부과되며, 동일한 서비스에 대한 장비의 추가 설치 시에는 별도의 비용이 부과되지 않습니다.
3. 서버설치는 IDC 시설의 안정적 운용과 타 회원의 시설 보호를 위하여 회사에서 제공하는 표준랙 당 설치할 수 있는 최대 서버 수를 1Unit 서버는 25개, 2Unit 서버는 16개로 제한합니다. 또한 표준랙당 전력소모량이 2.2kW(220V기준)를 초과하는 경우 회원은 회사와 사전 협의를 통해 장비를 재배치 하여야 하며, 재배치 불가시 회사는 회원에게 추가 전력비를 청구할 수 있습니다.
4. 회원이 고밀도집적서버를 설치 시에는 설치기준 및 전력비를 사전에 회사와 별도로 협의합니다.
5. 제4항의 경우 회사에서 제공하는 표준랙이 아닌 프리랙의 경우 전력 사용에 대한 내용은 회사와 회원 사이의 별도 이용계약에 의합니다.
6. 회원은 회사에 맞춤형 IT설비 서비스 제공을 요청할 수 있으며, 구체적인 내용은 제16조에 의합니다.
7. 회사는 실내 항온항습, 통신 및 전력 운영의 효율성을 위해서 회원장비의 재배치를 요구할 수 있고, 회원은 이에 따라야 합니다.`,
      },
      {
        title: '제9조 (불만처리)',
        content: `1. 맞춤형 IT설비 서비스의 이용요금은 별표 제2호(맞춤형 IT설비 서비스 이용요금표)와 같으며, UPS 및 항온항습기용 전력비는 별도로 청구됩니다. 
        2. 표준공급전압은 단상 220V, 3상 380V이며, 표준전압 및 서비스 목적 이외에 장비에 대한 전원설치는 회사와 사전에 협의 후 설치하는 것을 원칙으로 합니다. 
        3. 맞춤형 IT설비 서비스에 대한 회사의 전력공급 책임은 UPS에서 메인분전반까지 1차측으로 한정합니다. 
        4. 맞춤형 IT설비 서비스 이용 시 랙과 벽, 다른 랙열, 항온항습기, 전기분전반과의 거리는 일정거리 이상 유지하여야 하며, 회원장비의 배치는 회사와 사전 협의하여야 합니다. 
        5. 회원이 맞춤형 IT설비 이용 시 별도의 전기 및 네트워크 공사를 할 경우 반드시 회사와 사전 협의 하여야 하며, 계약 해지 시 전산실을 원상 복구하거나 또는 회사에 복구 비용을 현금으로 지불하여야 합니다. 
`,
      },
      {
        title: '제 16 조 (맞춤형 IT설비 서비스의 이용)',
        content: `1. 회사는 관련법과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 서비스를 제공하기 위하여 노력합니다.
2. 회사는 서비스 운영에 지장이 되는 장애가 발생했을 경우 이를 즉시 수리 또는 복구해야 하며, 안정적인 서비스 운영을 위해 최선을 다해야 합니다.
3. 회사는 회원의 개인정보보호를 위하여 보안시스템을 갖추어야 하며 개인정보처리방침을 공시하고 준수합니다.
4. 회사는 회원이 스팸메일 전송 등 불법행위를 한 사실을 확인한 경우, 한국인터넷진흥원, 경찰청 등 관계기관에 관련 자료를 첨부하여 신고할 수 있습니다.
5. 회사는 회원 중 고정 IP를 사용하는 개인 및 관리자 정보를 한국인터넷진흥원 등 인터넷주소관리기관에 최소한의 범위 내에서 제공할 수 있습니다.
6. 회사는 회원으로부터 제기되는 의견이나 불만이 정당하다고 인정되는 경우에는 이를 즉시 처리합니다. 회원이 이용신청 시 기입한 전화나 e-mail로 처리과정 및 결과를 통보할 수 있습니다.`,
      },
      {
        title: '제17조 (트래픽 제한)',
        content: `1. 회사는 회원이 실제로 이용하는 인바운드 트래픽(회원의 접속 포트가 수신하는 트래픽)이 이용계약 체결 시 선택한 인터넷접속서비스 총 용량의 10%를 초과할 경우 사전 통보 후, 인터넷접속을 제한할 수 있습니다.
2. 국제 전용 인터넷접속서비스를 이용하고자 하는 회원은 별도의 요금체계에 의한 인터넷접속서비스 계약을 체결하여야 합니다.
3. 회사는 국제 전용 인터넷접속서비스를 신청하지 않은 회원의 국제 트래픽 사용량이, 이용계약 체결 시 선택한 인터넷접속서비스 총 용량의 3%를 초과할 경우(3%를 초과하지 않는 경우라도 총 트래픽이 20M를 초과하는 경우) 사전 통보 후, 인터넷접속을 제한할 수 있습니다.
4. 단위 IT설비서비스당 전력이용량 과다 회원에 대해서는 사전통보를 통해 별도의 추가전력비를 청구할 수 있습니다.
5. 회원이 회사에서 임대한 장비 내에 별도의 전기 및 네트워크 공사를 할 경우 반드시 회사와 사전 협의 하여야 하며, 계약 해지 시 장비를 원상 복구하거나 회사에 복구 비용을 현금으로 지불하여야 합니다.`,
      },
      {
        title: '제18조 (호스팅 서비스의 이용)',
        content: `1. 회원은 회사로부터 장비를 임대 혹은 일정기간 사용 후 소유권 이전을 전제로 임대하는 호스팅 서비스를 이용할 수 있으며, 매월 장비 임대료를 납부해야 합니다.
2. 임대한 장비가 서비스 이용에 문제가 있을 경우 회사에 장비의 교체를 요청할 수 있으며 회사는 이에 즉각 응하여야 합니다. 단, 회원의 귀책 사유에 의한 망실의 경우 수리비용을 부담한 뒤 수리 후에 이용하여야 합니다.
3. 기간 계약을 한 임대 장비의 경우, 회사의 귀책 사유로 인한 해지의 사유를 제외하고, 계약 기간 이전에 이를 해약 시 제39조에서 정한 해지 위약금을 납입하여야 합니다.
4. 1개월 이상 임대 비용이 연체된 경우, 회사는 이에 대한 납부 또는 임대장비 반납을 통보하며, 일주일 이상 이의 납부가 이루어지지 않을 경우, 임대 장비를 강제 반납시킬 수 있습니다.
5. 임대 장비의 경우 IDC 밖으로의 반출이 불가능하며, 회원이 필요에 의해 반출을 원할 경우 서버 구매 금액만큼을 보증금으로 입금한 후에 반출할 수 있으며, 반납 시 보증금은 환불됩니다.
6. 회원에게 임대한 서버는 반납 이전에 서버 운영과 관련한 데이터를 백업 받아야 하며, 반납 절차 종료 후 시스템은 임의 포맷 환수되며, 이와 관련한 데이터의 망실 시 회사에 어떠한 피해 책임도 물을 수 없습니다.`,
      },
      {
        title: '제19조 (서비스 보안)',
        content: `1. 회원은 회사 또는 다른 사이트의 보안을 해치거나 시스템 자원을 부당하게 변경시키는 행위를 위해 회사의 시스템을 사용할 수 없습니다. 또한 보안을 해치는 수단 전파를 위해 회사 시스템을 사용하는 것도 금지되며 여기에는 암호추산 프로그램, 해킹 수단, 네트워크 탐색수단 등이 포함됩니다.
2. 회사는 보안관련 사건을 해결하기 위하여 해당 회원 시스템의 접속 관련 정보를 공유할 권리를 가집니다. 또한 회사는 혐의자 수사를 위하여 관련 기관에서 적법한 절차에 따른 요구가 있는 경우 이에 협조합니다. 단, 회사는 회원에게 이 사실을 즉시 통보합니다.`,
      },
      {
        title: '제20조 (기타 서비스의 이용)',
        content: `1. 회원은 별도의 이용신청을 통하여 부가 서비스를 이용할 수 있으며, 구체적 종류와 이용요금은 별도 규정에 의합니다.
2. 회원은 자신이 지정한 장소와 회사의 IDC 내에 설치된 자신의 장비를 전용회선(45Mbps 이하의 TDM방식만 허용)으로 연결하고자 할 경우, 회사가 지정하여 관리하고 있는 장소에 설치된 회선사업자의 광 장비 시설과 회원장비 간에 구내회선을 설치하는 ‘구내회선 설치 서비스’를 이용할 수 있습니다. 회원은 회사에게 회선사업자명, 설치목적, 전용회선의 종류와 설치장소 등 세부사항을 설치 일주일 전까지 제공해야 합니다. 이때 건물 내 구내회선과 단자함공사는 회사가 시행하며, 건물 내 관로, 전기 등 관련 설비가 부족할 경우, 구내회선 설치서비스가 제공되지 않을 수 있습니다. ‘구내회선 설치 서비스’이용요금은 별표 제1호(코로케이션 서비스 이용요금표)에 의합니다.`,
      },
      {
        title: '제21조 (IP Address 및 DNS)',
        content: ` 1. 회원의 장비에 설치될 IP Address는 회원의 시스템 규모에 따라 한국인터넷정보센터(KRNIC)의 제 규정 및 회원과 회사의 상호 협의하에 회사로부터 할당 받는 것을 원칙으로 합니다. 또한 회원이 자체 Domain Name Server가 없을 시에는 회사의 Domain Name Server를 이용할 수 있습니다.
2. 회사는 공공기관(검찰청, 경찰청 등) 등 외부로부터 회원의 IP Address에 대한 정보제공의 요청이 있는 경우 인터넷회선 이용시에 보편적으로 공개되는 정보인 개인명, 담당자명, 담당자연락처에 한하여 회원의 동의 없이 정보를 제공할 수 있습니다.
3. 회원 중 고정 아이피 주소를 사용하고자 하는 개인 또는 이용기관의 관리자 정보는 인터넷 주소관리의 WHOIS 서비스에 최소의 범위 내에서 제공될 수 있습니다. 단, 회원은 공개되는 정보 중 일부(이름, 상세주소, 전화번호)에 대해 비공개하도록 요청할 수 있습니다.`,
      },
    ],
  },
  {
    title: '제4장 서비스의 제한',
    sub: [
      {
        title: '제22조 (서비스의 중단)',
        content:
          '1. 회사는 회원에게 안정된 서비스를 제공하기 위하여 24시간 365일 전체 네트워크를 점검하여야 하며 이를 위하여 정기적, 비정기적 운영점검을 실시합니다. 그 내용은 다음 각 호와 같습니다.\n① 정기적 운영점검: 회사는 전체 네트워크 백본의 이상 유무를 점검하고, 전송효율을 높이기 위하여 주기별로 해당 점검일 오전 05시～07시 사이에 정기적 운영점검을 실시하며, 관련 내용을 사전에 회원에게 통보합니다.\n② 비정기적 운영점검: 회사는 전체 네트워크 백본의 효율을 높이거나, 네트워크가 불특정 원인으로 인하여 오동작을 발생시킬 경우나, 회원 내부 네트워크의 문제점을 해결하기 위하여 비정기적 운영점검을 실시할 수 있습니다.',
      },
      {
        title: '제23조 (서비스의 제한)',
        content:
          '1. 회사는 다음 각 호의 경우 1개월 이내의 기간을 정하여 회원의 서비스 이용을 제한하거나 중지시킬 수 있습니다.\n① 회원이 회사 서비스의 운영을 고의•과실로 방해하는 경우\n② 회원이 제11조 및 본 약관상의 의무를 위반하는 경우\n③ 회원이 스팸메일을 전송하거나 바이러스 유포, 기타 네트워크 장애를 유발하는 행위를 한 경우\n④ 스팸릴레이로 이용되거나 웜에 감염되어 스팸메일을 전송한 경우\n⑤ 서비스를 범죄에 이용한다고 객관적으로 판단되는 경우\n⑥ 회원 서버가 이용계약 체결에 따른 네트워크 대역을 초과하여 사용하는 경우\n⑦ 회원 서버가 해킹되었거나, 바이러스에 감염된 것으로 의심되는 경우\n⑧ 회원 서버가 과다한 전기를 사용하거나 발열로 인하여 회사의 서비스 운영에 지장이 발생될 것으로 예상되는 경우\n⑨ 과도한 국제 회선 사용으로 인하여 기간통신사업자로부터 이의 해소를 요구 받은 경우\n⑩ 정부 기관이 증거 자료 확보를 이유로 적절한 법적 절차를 거쳐 운영 서버에 대한 일시적인 서비스 중지를 요청한 경우\n⑪ 방송통신위원회, 미래창조과학부 또는 한국인터넷진흥원 등 관련 기관이 스팸메일 등 불법행위의 전송 사실을 확인하여 이용정지를 요청하는 경우\n⑫ 회원이 회사의 허락 없이 기본 포트(telnet, FTP, web 등) 이외 다른 포트(시스템에서 각각의 서비스를 구분하기 위해 사용되는 번호)를 점유하는 임의의 데몬(시스템에서 대기하면서 사용자의 요청에 대해 미리 지정된 규칙에 따라 응답 및 통신하기 위해 사용되는 프로그램)을 사용한 경우\n2. 회원은 이용정지 시작일로부터 1개월 이내에 그 사유를 해소하여야 하며, 회사는 이용정지의 사유가 해소되면 즉시 서비스의 이용을 가능하게 합니다.\n① 회사는 12개월 이상 서비스를 이용하지 아니하는 이용자의 개인정보를 보호하기 위해 서비스 이용 계약을 해지하거나 개인정보의 파기 등 필요한 조치를 할 수 있습니다.\n② 회사는 휴면 계정 기간 만료 30일 전까지 개인정보가 파기되거나 분리되어 저장되는 사실과 기간 만료일 및 해당 개인정보의 항목을 전자우편, 서면, 모사전송, 전화 또는 유사한 방법 중 하나의 방법으로 이용자게 알리도록 합니다.\n③ 제3항에 따른 서비스 이용 계약의 해지의 삭제에 대한 책임은 회원이 부담하며, 회사는 고의 또는 과실이 없는 한 데이터 삭제에 따른 책임을 부담하지 않습니다.',
      },
      {
        title: '제24조 (서비스 초과 회원의 이용제한 및 해제 절차)',
        content:
          '1. 회사는 신청한 서비스를 초과(트래픽, 용량 등)한 회원에 대해서 회사에 등록되어 있는 연락처로 이 사실을 통보하고, 회원은 최초 통보 받은 후 24시간 이내로 상위서비스로 신청하거나 초과부분의 원인제거를 통하여 현재의 서비스 허용량 이하로 조정해야 합니다.\n2. 회원이 제1항의 초과 통보를 받고도 전항의 의무를 이행하지 않는 경우에는 회사는 회원의 서비스 이용을 일시적으로 제한할 수 있으며, 회원이 이용제한 사유를 해소하는 경우에는 관련 절차에 따라 이용제한조치를 즉시 해제합니다.',
      },
      {
        title: '제25조 (서비스 유보)',
        content:
          '1. 회원이 일시적인 서비스 유보의 필요가 발생하여 이에 대한 요청이 있을 경우, 회사는 다음 각 호의 요건을 갖춘 회원에게 요청 기간 동안 서비스 제공을 일시 유보합니다.\n① 회사에서 Domain Name을 관리할 것\n② 6개월 이상 서비스 중일 것\n③ 요금 미납이 없을 것\n④ 유보 요청기간은 최대 30일 이하일 것\n⑤ 1년에 1회만 신청 가능\n⑥ 서비스 안정화 및 무료 사용기간이 없을 것\n2. 서비스 유보 시 회사는 회원의 URL에 대한 IP를 변경하여 회원의 사이트상에 서비스 유보에 대한 안내 텍스트를 제공하며, 회원이 자사 사이트에 게재될 안내 내용을 제출할 경우 이를 제공합니다.\n3. 서비스 유보 시 회사는 장비를 동일 장소에 보관하며, 장비에 대한 전원공급을 중단합니다. 이 경우 장비의 정상적인 전원공급 중단을 위하여 회원은 회사에 필요한 협조를 하여야 하며, 협조를 하지 않아 발생하는 손해에 대해서는 회사가 책임을 지지 않습니다.\n4. 회사는 서비스가 유보된 회원에게 해당 유보 기간 중 기존에 회원이 납부하는 서비스 이용요금의 20%만 청구하며, 인터넷접속이용에 대한 비용은 청구하지 않습니다.\n5. 서비스 유보 기간이 경과하면 서비스는 정상적인 상태로 자동 복귀합니다.',
      },
      {
        title: '제26조 (서버의 고장 수리)',
        content:
          '1. 회사는 현장 유지 보수가 가능하도록 장비의 최종 판매일로부터 2년간은 동종 또는 유사 사양의 대체 장비를 보유할 의무를 가집니다.\n2. 전1항 장비의 고장 수리는 회사의 소재지와 회사가 이용하는 IDC에서만 제공합니다.\n3. 회원이 구매한 상품에 대한 무상 수리 보증 기간은 설치일을 기준으로 1년이며, 이후 발생한 수리의 경우 유상으로 처리를 기본으로 합니다. 단, 1년이 경과하더라도 서버 생산 판매 업체가 무상 고장 수리를 해 줄 수 있는 경우는 무상으로 처리합니다.\n4. 회사가 회원에게 임대한 장비의 경우 고장 시 임대 기간 동안은 무상으로 서비스되며, 소유권이 회원에게 이전되었을 경우 처음 장비를 이용한 날을 기준으로 하여 1년 이내인 경우는 무상, 1년이 지난 경우는 유상으로 서비스됩니다. 단, 회원에게 소유권이 이전 된 장비의 경우, 1년이 경과하더라도 서버 생산 판매 업체가 무상 고장 수리를 해 줄 수 있는 경우는 무상으로 처리합니다.\n5. 무상 수리 보증 기간내의 제품이라 할지라도 회원의 과실로 인한 파손 및 손상이 있을 경우 유상으로 처리되며, 소모품 또는 마모성 부품은 제품의 보증기간과 관계없이 유상으로 처리합니다.\n6. 회원은 데이터 저장 장치의 장애에 대비하여 자신의 서버에 대한 주기적인 데이터 백업을 하여야 합니다.\n7. 회사에서 제공하지 않은 장비의 고장에 대하여는 회사는 책임을 지지 아니합니다.',
      },
      {
        title: '제27조 (서비스 이용 중 장비의 반출)',
        content:
          '1. 회원은 코로케이션 서비스 이용 중 필요에 의하여 장비를 IDC 외부로 반출할 수 있으며, 서비스 이용 요금에 대한 연체한 사실이 없는 경우에 한하여 장비의 반출이 가능합니다.\n2. 장비의 반출 기간 동안 서비스의 이용이 이루어지지 않고 있다 하더라도 서비스 이용 요금은 동일하게 부과됩니다.\n3. 장비 반출은 회사가 요청하는 일정 양식 및 절차에 따라야 하며, 회원 본인이 직접 반출하지 않는 경우는 위임장을 첨부하여 대리인을 통해 반출할 수 있습니다.',
      },
      {
        title: '제28조 (IDC 출입)',
        content:
          '1. 회원은 IDC 방문을 원할 경우 IDC인터넷 홈페이지(www.dnacloud.co.kr) 또는 전화로 사전예약을 하여야 합니다.\n2. IDC 출입은 예약확인 절차를 거쳐 출입증을 발급 받은 후 가능하며, 수시로 출입하는 시스템 담당자는 회사로부터 사전 출입권한을 부여 받아 출입절차를 간소화 할 수 있습니다.\n3. 회원이 출입권한을 받아 IDC에 출입 시 반드시 허가된 구역만을 접근하여야 합니다.\n4. 회원은 회원장비 이외에는 어떠한 시설에도 접근하여서는 안됩니다.',
      },
      {
        title: '제29조 (정보의 제공)',
        content:
          '회사는 회원이 서비스 이용 중 필요하다고 인정되는 경우 다양한 정보를 공지사항이나 e-mail 등의 방법으로 회원에게 제공할 수 있습니다. 다만, 회원은 관련법에 따른 거래관련 정보 및 회원문의 등에 대한 답변 등을 제외하고는 언제든지 e-mail에 대해서 수신 거절을 할 수 있습니다.',
      },
      {
        title: '제30조 (권리의 귀속)',
        content:
          '1. 서비스에 대한 저작권 및 지적재산권은 회사에 귀속됩니다.\n2. 회원은 서비스에 관하여 사용권을 부여 받으며 이를 양도, 증여, 질권의 목적으로 사용할 수 없습니다.',
      },
    ],
  },
  {
    title: '제5장 서비스의 변경',
    sub: [
      {
        title: '제31조 (이용계약의 변경)',
        content:
          '1. 회원은 서비스 이용계약 내용 중 다음에 해당하는 변경 사유가 발생한 즉시 관련 절차에 따라 변경 신청해야 하며, 이와 관련한 정보 변경의 지연으로 인한 문제 발생 시 그 책임은 회원에게 있습니다.\n① 회원 및 사실상 요금 납입의 책임을 지기로 한 자의 상호, 성명 또는 주소의 변경\n② 계약 종류(상품의 종류, 회선의 종류, 접속 회선의 대역, 이용계약기간, 이용목적) 의 변경\n③ 요금납부방식 및 결제계좌번호 변경\n④ 이용계약 기재의 담당자 정보(연락처 포함)\n2. 회원이 회사가 청구한 서비스 이용 요금을 체납하고 있는 경우, 회사는 변경 신청을 제한할 수 있습니다.\n3. 설비의 여유가 없거나, 기술상 서비스 제공이 어렵거나 회사의 서비스 정책이 변경되는 경우에 회사는 변경 신청을 제한할 수 있습니다.',
      },
      {
        title: '제32조 (이용계약의 갱신)',
        content:
          '이용계약기간 만료 30일전까지 회원과 회사 상호간에 별도의 의사표시가 없으면 이전의 계약 내용과 동일한 조건으로 계약이 갱신되는 것으로 봅니다.',
      },
      {
        title: '제33조 (회원의 계약의 해제 및 해지)',
        content:
          '1. 회원은 이용계약을 해지하고자 하는 경우, 최소 30 일 이전에 회사에 통보해야 하며, 회원이 원하는 해지 일자를 기준으로 미지불 서비스 이용 요금이 발생한 경우, 이에 대하여 지불을 완료하여야만 해지 절차가 마무리 됩니다.\n2. 기간에 대한 계약이 있는 경우, 회원의 귀책 사유로 인한 서비스 해지 시 제39조에 의하여 위약금을 청구할 수 있습니다.',
      },
      {
        title: '제34조 (회사의 계약의 해제 및 해지)',
        content:
          '1. 회사는 회원이 본 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 명의도용, 저작권법을 위반한 불법프로그램의 사용 및 운영방해, 회사와 기타 제3자의 지적재산권에 대한 침해, 회사가 제공 또는 승인하지 아니한 컴퓨터 프로그램이나 기기 또는 장치를 제작•배포•이용•광고, 정보통신망법을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 계약을 해제 및 해지할 수 있습니다.\n2. 회사는 회원이 30일 이상 서비스 요금을 연체한 경우 직권으로 서비스를 정지할 수 있으며, 서비스 정지 후 5일 이내에 납입 불이행이 해결되지 않을 경우 직권으로 서비스를 해지할 수 있습니다. 다만, 회사가 특별히 승인한 경우에 한하여 최대 60일까지 서비스 정지일이 연장될 수 있습니다.\n3. 제23조에 따른 이용제한 또는 중지의 사유가 1년 이내에 재발한 경우 즉시 계약을 해제 및 해지할 수 있습니다.\n4. 제24조에 따른 해소요구에 대하여 적절한 조치가 없는 경우 즉시 계약을 해제 및 해지할 수 있습니다.\n5. 한국인터넷진흥원장이 스팸메일 등 불법행위의 전송사실을 확인하여 서비스 계약 해지를 요청하는 경우 즉시 계약을 해제 및 해지할 수 있습니다.\n6. 본 조에 따라 계약을 해제 및 해지하는 경우 회원의 e-mail 혹은 전화로 회원에게 통지합니다.',
      },
      {
        title: '제35조 (계약 해지 회원 소유 장비의 처리)',
        content:
          '1. 이용계약 해지 시 회원은 해지일부터 기산하여 5일이내 회사의 IDC에서 자신의 장비를 반출하여야 하며, 제27조와 동일한 절차에 의하여 반출합니다.\n2. 회원은 제1항의 기한을 도과하여 장비를 반출하는 경우, 해지일부터 장비의 실제 반출일까지 장비의 보관에 대한 대가로서, 기존 이용계약에 따른 서비스 이용요금을 일할 계산하여 회사에 지불하여야 합니다.\n3. 서버의 반출 시 회원의 직접 반출을 원칙으로 하며, 회원이 사정에 의하여 택배나 대행 업체를 이용한 발송을 요청하는 경우 발송으로 인한 분실 또는 파손에 대하여 회사는 책임지지 않습니다.\n4. 제1항의 기한 내에 장비를 반출하지 않는 경우, 회원에게 e-mail 또는 전화로 장비의 반출을 요청하며, 회원은 회사의 요청으로부터 24시간 이내 적절한 조치를 취하여야 합니다. 회사는 전단의 시한 내에 회원이 적절한 조치를 취하지 않을 경우 즉시 회원의 장비를 회사가 지정한 장소로 반출 및 이동할 수 있습니다.\n5. 회사는 제4항에도 불구하고 회사가 1개월 이상 회원의 장비를 보관하게 되는 경우, 회사는 다시 1개월 이상의 기간을 정하여 회원에게 데이터 백업의 요청, 장비의 반출 및 임의처분 예정에 대하여 최고합니다. 회원이 최고한 기간까지 장비를 반출하지 않는 경우, 회사는 회원이 미납한 이용요금, 위약금, 반출일까지 장비 보관비용 등의 충당을 위하여 회원의 장비를 임의처분(경매, 임의매각 등) 할 수 있으며, 이와 관련하여 회원은 회사에 자신이 데이터 백업 조치를 하지 않아 발생한 책임 및 장비 반환 책임을 물을 수 없습니다.\n6. 회사는 제5항의 임의처분에도 불구하고 회원이 미납한 비용을 온전히 충당하지 못하는 경우, 회원에게 미충당된 비용의 납부를 청구합니다. 회원은 회사의 청구일로부터 15일 이내 해당 비용을 납부하여야 합니다.\n7. 회사는 제4항 및 제5항에 의한 장비의 반출 중 자신의 중과실 및 고의에 의해 발생한 손해를 제외하고, 회원이 제6조 및 제31조1항의 의무를 게을리하여 발생한 손해에 대하여 일체의 책임을 부담하지 않습니다.\n8. 회원이 서비스 이용계약 해지 후 재사용할 경우 각 회사의 IP 사용기준에 따라서 변경된 IP 를 할당 받을 수 있으며 서버의 위치 또한 변경되어 서비스 재개될 수 있습니다. 또한 해지된 후 이에 대한 재사용을 원하는 경우 회원은 다시 신규 서비스 신청을 하여야 하며 이에 따라 신규 설치비가 부과될 수 있습니다.',
      },
    ],
  },
  {
    title: '제6장 이용요금',
    sub: [
      {
        title: '제36조 (이용요금의 종류 및 계산방법)',
        content:
          '1. 서비스 이용과 관련하여 회원이 납입하여야 할 이용요금의 종류는 다음 각호와 같으며 그 이용요금의 세부내역은 별표 제1호 및 2호와 같습니다.\n① 설치비: 신규 서비스 개통 또는 서비스 이용 중에 재설치, 변경을 하는 경우에 지급하는 장비 공급 대금 또는 기술지원 이용 요금(신규 서비스 또는 설치변경 작업을 위하여 1 회만 지불하는 요금이며, 납부 후에는 환불되지 않습니다)\n② 서비스 이용요금: 서비스 종류별로 정해져 있는 기본요금\n③ 추가 이용요금: 서비스 기준 초과 또는 별도의 부가 서비스에 대한 이용요금\n2. 계약기간 중 회사에 의해 요금의 변동이 있을 경우 공시한 즉시 변경된 요금을 적용합니다. 단 회사와 회원의 합의가 있을 경우 합의 내용이 우선적으로 적용됩니다.\n3. 요금납부방법은 후납이며 일액, 월액으로 계산됩니다.\n4. 일 사용액의 계산은 0시부터 24시까지를 1일로 하는 것이며, 서비스 제공 개시일의 익일부터 계산합니다.\n5. 월 사용액 계산은 매월 1일부터 말일까지 해당월의 이용요금으로 하며 서비스 개통일, 변경일, 해지일이 당해 요금월의 중도인 경우에는 이용요금을 당해 월의 이용일수로 계산하는 일할 계산을 합니다. 이 경우 변경일은 변경일자부터 이용일수에 포함하여 계산합니다.\n6. 이용요금을 계산하는 경우에는 해당 요금월의 일수로 나눈 금액을 월액 요금의 일할로 산정합니다.\n7. 서비스 개설시의 설치비는 1회에 한하여 청구하며 요금 청구 첫 번째 월 요금에 포함하여 청구합니다.',
      },
      {
        title: '제37조 (이용요금의 청구 및 납입)',
        content:
          '1. 회사는 이용요금납입을 위한 청구서를 매 사용월의 당월(종량제 서비스의 경우 서비스 사용월의 익월 발송) 중순경에 회원에게 발송하며, 회원은 청구서에 기재된 기일(공휴일인 경우 익일)까지 요금을 납입하여야 합니다.\n2. 회원이 국가기관, 지방자치단체, 주한 외국기관이거나 회사가 인정할 경우에는 중앙불(상급기관이나 주된 사업소 등에서 일괄하여 지불하는 것)로 납입할 수 있습니다.\n3. 단기이용요금은 서비스 이용을 1개월 미만으로 하는 회원(단기이용회원)이 납입하는 요금을 말하며, 이용요금은 신청 서비스의 규모 및 기간 등을 고려하여 회사와 회원 사이에 별도 협의를 거쳐 산정합니다.\n4. 회사는 서비스의 단기이용회원에게 이용요금 납입의 이행확보를 위하여 예치금을 납입하게 할 수 있습니다.\n5. 회사가 제공하는 서비스에 대한 이용요금은 계좌이체, 무통장입금 의 방법으로 결제할 수 있습니다.\n6. 회원은 서비스에 대한 이용요금을 성실히 납부하여야 하며, 이용요금 납부의 지연 시에는 미납요금 총액의 2%의 가산금을 회사에 지급하여야 합니다.',
      },
      {
        title: '제38조 (이용요금의 환불 및 이의제기)',
        content:
          '1. 회사는 과오금이 발생한 경우 이용대금의 결제와 동일한 방법으로 과오금을 환불하여야 합니다. 다만, 동일한 방법으로 환불이 불가능한 경우에는 이를 사전에 고지합니다.\n2. 회원이 납부한 이용요금의 과납 또는 오납이 있을 경우 회사는 과오금을 환불하거나 발생 예정의 이용요금과 상계할 수 있습니다. 다만, 이용요금의 반환을 받아야 할 회원에게 요금 등의 체납이 있을 경우에는 반환하여야 할 금액에서 우선 공제할 수 있습니다.\n3. 회원은 이용대금에 대하여 이의를 제기할 수 있습니다. 단, 이용대금에 관한 이의는 그 사유 발생을 안 날로부터 1월, 그 사유가 발생한 날로부터 3월 이내에 제기하여야 합니다.\n4. 회사는 제3항의 이의신청 접수 후 2주 이내에 해당 이의신청의 타당성 여부를 조사하여 그 결과를 회원에게 통지합니다. 단, 부득이한 사유로 인하여 2주 이내에 해당 결과를 통지할 수 없는 경우에는 그 사유와 재 지정된 처리기한을 명시하여 회원에게 통지합니다.\n5. 본 조의 규정에 의한 환불은 환불 의무가 발생한 날로부터 3영업일 이내에 하는 것으로 하며 대금의 결제와 동일한 방법으로 이를 환급하여야 합니다. 다만, 동일한 방법으로 환불이 불가능할 때에는 이를 사전에 고지하여야 합니다.\n6. 환불에 소요되는 비용은 회원의 귀책사유로 인한 환불의 경우에는 회원이, 회사의 귀책사유로 인한 환불의 경우에는 회사가 각각 부담합니다.',
      },
      {
        title: '제39조 (위약금)',
        content:
          '1. 계약기간 만료 전 회원의 귀책사유로 해지하는 경우이거나 회원의 사정에 의해 해지하는 경우에는 다음에 해당하는 위약금을 회사에 납부하여야 합니다.\n① 잔여개월 이용요금의 50%에 해당하는 금액 (월 이용료 * 잔여개월 수 * 50/100)\n② 월 수 계산에서 1개월 기준 16일 이상 사용하였을 경우 1개월 사용한 것으로 간주합니다.\n2. 회원은 안정화 또는 무료 사용기간을 제공받은 경우, 제1항의 위약금에 안정화 또는 무료로 제공받은 서비스 내역을 금액으로 환산한 금액을 합하여 위약금으로 납부하여야 합니다.\n3. 제1항의 규정에도 불구하고 다음 각호의 경우 회원은 위약금 없이 계약을 해지할 수 있습니다.\n① 회사의 귀책사유로 월 고장누적시간이 72시간 이상 발생한 경우\n② 회사의 귀책사유로 1시간 이상의 고장이 월 5회 이상 발생한 경우',
      },
      {
        title: '제40조 (면탈요금의 징수)',
        content:
          '회사는 회원이 이 약관의 규정을 위배하여 서비스 이용요금을 면탈하는 행위를 한 경우 동 면탈한 금액의 2배에 해당하는 금액을 청구할 수 있습니다.',
      },
      {
        title: '제41조 (손해배상)',
        content:
          '1. 회사가 고의 또는 과실로 회원에게 손해를 발생시킨 경우, 손해에 대하여 배상할 책임이 있습니다.\n2. 회사는 회사의 명백한 귀책사유로 이용고객이 서비스를 이용하지 못하는 경우에는 이용고객이 그 사실을 회사에 통보하여 확인한 시점 (또는 그 전에 회사가 그 사실을 알았거나 알 수 있게 된 시점)부터 1시간 이상의 서비스제공 중지시간에 대하여 최근 3 개월 (3 개월 미만인 경우는 해당기간 적용) 의 1 일 평균요금을 24(시간) 로 나눈 수를 서비스 중지시간과 곱하여 산출한 금액의 3 배를 기준으로 하여 협의 후 배상합니다. 이 경우 단수가 1 시간 미만인 경우에는 1 시간으로 합니다.\n3. 회원이 본 약관을 위반하여 회사에 손해를 발생시킨 경우, 회원은 회사에 대하여 그 손해를 배상할 책임이 있습니다.\n4. 회원은 스팸메일 전송 등 불법행위를 하거나 전기통신사업법 등 관련 법령을 준수하지 못해 발생하는 모든 민형사상의 책임을 부담합니다.',
      },
    ],
  },
  {
    title: '제7장 전자적 침해사고 예방 및 대응',
    sub: [
      {
        title: '제42조 (전자적 침해사고 등의 정의)',
        content:
          '1. “전자적 침해행위”라 함은 정보시스템을 대상으로 해킹, 컴퓨터바이러스, 논리-메일폭탄, 서비스거부 또는 고출력 전자기파 등에 의하여 정보시스템을 공격하는 행위를 의미합니다.\n2. “전자적 침해사고”라 함은 침해행위로 인해 발생한 사태를 의미합니다.\n3. “보안 위협”이라 함은 정보시스템에 손실을 발생시키는 원인이나 행위 또는 보안에 해를 끼치는 행동이나 사건을 의미합니다.\n4. “보안 취약점”이라 함은 보안 위협의 대상이 되는 정보시스템의 약점을 의미합니다.',
      },
      {
        title: '제43조 (회사의 역할)',
        content:
          '1. 회사는 회원의 정보통신시스템에 위협이 될 수 있는 해킹, 컴퓨터바이러스 관련 정보 및 새로운 보안 취약점 관련 정보를 인터넷 메일 또는 홈페이지를 통해 수시로 회원에게 제공합니다.\n2. 회사는 회원장비 및 IDC 전체 네트워크의 안전, 신뢰성 제고를 위해 회원 동의하에 회원 내부 네트워크의 보안취약점 분석을 시행 할 수 있습니다.\n3. 회사는 회원의 보안의식 고취 및 침해사고 예방을 위한 기술제공을 위하여 매분기 1회 이상 무료 교육을 실시합니다.\n4. 회사는 침해사고를 접수, 처리할 수 있는 담당부서를 다음과 같이 지명하여 운영합니다.\n- 담당부서: 기술지원팀\n- 전화: 02-6406-6100\n- 팩스: 02-6499-0126\n- 메일: sales@dnacloud.co.kr',
      },
      {
        title: '제44조 (회원의 역할)',
        content:
          '1. 회원은 침해사고를 예방하기 위하여 회원이 관리하는 정보시스템에 대한 적절한 보안조치를 취하여야 합니다.\n2. 회원은 회사가 제공하는 예•경보 및 보안관련 정보를 받아보고 침해사고 예방을 위한 지시사항을 성실히 이행해야 합니다.\n3. 회원은 회사 또는 타사의 보안을 위협하는 다음과 같은 침해행위를 위해 회사의 정보시스템 또는 회원의 정보시스템을 사용할 수 없습니다.\n① 컴퓨터 바이러스 등 악성프로그램 유포 행위\n② 회원 정보시스템 이외의 시스템을 대상으로 한 취약점 스캐닝 행위\n③ 회원 정보시스템 이외의 시스템을 대상으로 한 비인가된 불법침입 행위\n④ 대량의 트래픽 유발 등을 통해 정상적인 서비스를 방해하는 행위\n⑤ 기타 회사의 정상적인 서비스 제공을 방해할 수 있는 각종 침해행위\n4. 회사 침해사고 담당자와 24시간 연락이 가능한 비상연락 담당자를 선정하고 담당자의 전화, 휴대폰, 인터넷메일 주소를 비상연락망에 등록하여야 합니다. 담당자의 연락처가 변경된 경우, 이를 즉시 비상연락망에 반영하여야 합니다.\n5. 회원은 관리중인 정보시스템에 이상징후가 발견되거나 침해사고가 발생한 경우, 즉시 회사 침해사고 접수처에 통보하여야 합니다.',
      },
    ],
  },
  {
    title: '제8장 스팸메일',
    sub: [
      {
        title: '제45조 (스팸메일 등의 정의)',
        content:
          '1. 스팸메일이란 정보통신망을 통해 수신자가 원하지 않는데도 불구하고 일방적으로 전송 또는 게시되는 영리목적의 광고성 전자우편을 말합니다.\n2. 불법 스팸메일이란 관계법률 또는 본 약관을 위반하여 회사 서비스를 통해 전송 또는 게시되는 스팸메일을 말하며, 타사업자가 제공하는 서비스를 이용하여 발송된 스팸메일인 경우에도 그 내용과 관련(링크)된 사이트가 회사의 서비스를 이용중인 경우를 포함합니다.',
      },
      {
        title: '제46조 (불법 스팸메일 발송의 금지)',
        content:
          '1. 회원은 관계법령 및 본 약관을 위반하여 불법 스팸메일을 발송할 수 없습니다.\n2. 회원은 선량한 풍속과 사회질서를 해하는 음란, 폭력, 사기 등 청소년에게 유해한 내용을 포함한 전자우편을 발송할 수 없습니다.\n3. 회원은 ‘정보통신망이용촉진및정보보호등에 관한 법률’의 제규정 및 ‘스팸메일방지 가이드라인’에서 규정한 광고성 전자우편 전송형식의 기준을 준수하여야 합니다. 이 경우에도 제목에 ‘광고’라는 용어를 사용하여 수신자가 광고성 전자우편임을 쉽게 인식할 수 있도록 하여야 합니다.',
      },
      {
        title: '제47조 (전자우편주소의 수집ㆍ매매 등 금지)',
        content:
          '1. 회원은 전자우편주소 추출기 등을 이용하여 다른 회원의 전자우편 주소를 수집 또는 제3자에게 매매ㆍ제공할 수 없습니다.\n2. 회사는 전자우편주소 추출기 또는 전자우편주소 생성기 등을 이용하여 무작위로 전송되는 전자우편을 차단할 수 있으며, 이러한 조치로 인하여 전자우편이 수신자에게 도달하지 못한 것에 대하여 책임지지 않습니다.\n3. 회사는 회원이 제1항 및 제2항의 규정을 위반하여 회사 및 다른 회원에게 정신적ㆍ물질적 손해를 끼친 경우에는 민사 또는 형사 소송을 제기하여 그 손해에 대한 책임을 물을 수 있습니다.',
      },
      {
        title: '제48조 (해외로의 스팸메일 발송 금지)',
        content:
          "1. 스팸메일 발송회원은 한글로 작성된 광고성 전자우편을 한글 해독능력이 없는 해외의 외국인에게까지 무분별하게 전송할 수 없습니다.\n2. 해외로 보낼 의도가 없는 메일의 경우 .kr 이나 국내 포탈사이트의 이메일주소 등 국내 이메일주소로 확인 가능한 경우에만 메일발송을 해야 합니다.\n3. 해외 메일 발송으로 인해 다른 회원의 IP까지 해외에서 블록킹되는 경우 스팸메일 발송회원은 그 책임을 집니다.\n4. 스팸메일 발송회원은 해외의 외국인에 대한 광고를 목적으로 광고성 전자우편을 전송할 경우에는 영어 또는 해당국가의 언어로 작성된 광고성 전자우편만을 전송해야 합니다. 또한 이 경우에는 제목란에 ‘ADV' 또는 ’ADV:ADLT'라는 용어를 사용하여 수신자가 광고성 전자우편임을 쉽게 인식할 수 있도록 하여야 합니다.",
      },
      {
        title: '제49조 (수신거부 회피의 금지)',
        content:
          '1. 스팸메일 발송회원은 광고성 전자우편을 전송할 때 수신거부를 회피하기 위해 메일헤더가 조작된 전자우편 또는 자신의 연락처에 관한 정보(명칭, 전자우편주소, 전화번호 및 주소)를 허위로 기재한 전자우편을 전송할 수 없습니다.\n2. 스팸메일 발송회원은 광고성 전자우편을 전송할 때 수신자의 수신거부를 회피하기 위해 광고성 전자우편의 내용란에 수신거부버튼ㆍ링크 등 수신거부방법을 허위로 설정하면 안됩니다.\n3. 스팸메일 발송회원이 광고성 전자우편에 수신거부를 링크시킨 경우에도, 수신거부 기능이 정상적으로 작동하지 않아 수신거부 의사를 표현한 수신자에게 지속적으로 스팸메일이 발송되면 수신거부 회피의 경우와 동일한 것으로 간주합니다.',
      },
      {
        title: '제50조 (스팸메일과 관련된 책임)',
        content:
          '1. 회사는 서비스 제공 목적에 맞는 서비스 이용여부를 확인하기 위하여 상시적으로 모니터링을 실시합니다.\n2. 회사는 회원이 관계법령 및 본 약관에서 규정한 스팸메일 관련 사항을 준수하지 아니할 경우 당해 회원에게 회사가 제공하는 서비스의 전부 또는 일부를 제한하거나 정지할 수 있습니다.\n3. 회사는 회원이 관계법령에서 정하는 사항을 위반한 경우 정보통신부 등 관계 행정청이나 사법당국에 신고ㆍ고발할 수 있습니다.\n4. 회사는 회원이 불법한 광고성 전자우편 전송을 금지하는 관계법령 및 본 약관의 규정을 위반하여 회사나 다른 회원에게 손해를 끼친 경우에는 민사소송을 통해 그 손해에 대한 책임을 물을 수 있습니다.',
      },
    ],
  },
  {
    title: '제9장 기 타',
    sub: [
      {
        title: '제51조 (회원의 법적 지위승계)',
        content:
          '1. 상속, 합병, 분할, 영업양수 등으로 회원의 법적 지위의 승계 사유가 발생한 때에는 그 사유가 발생한 날로부터 30일 이내에 사업자등록증사본(개인은 주민등록증사본)과 지위승계를 입증할 수 있는 관련서류를 첨부하여 회사가 지정한 절차에 따라 신청하여야 합니다.\n2. 회원의 지위가 승계될 경우에는 기존의 미납된 서비스 이용 요금 납입 의무도 승계되는 것으로 간주합니다.',
      },
      {
        title: '제52조 (책임제한)',
        content:
          '1. 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 대한 책임이 면제됩니다.\n2. 회사는 사전에 공지된 설비의 보수, 교체, 정기 및 비정기 점검, 공사 등 부득이한 사유로 서비스가 중지되거나 장애가 발생한 경우에 대해서 책임이 면제됩니다.\n3. 회사는 자신이 제공하지 않은 장비로 인한 서비스 장애에 따른 회원의 부가적, 영업적인 손해에 대해서는 책임을 지지 않습니다.\n4. 회사에서 제공하는 백업서비스를 이용하지 않는 회원은 자체적으로 항상 백업을 하여야 하며, 이를 수행하지 않아 발생하는 피해에 대해서 회사는 어떠한 책임도 지지 않습니다.\n5. 회사는 전기통신사업법에 규정된 기간통신사업자 및 회원의 귀책사유로 인한 서비스 이용의 중지 또는 장애에 대하여는 책임을 지지 않습니다.\n6. 회사는 회원간 또는 회원과 제3자 상호간에 서비스를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다.\n7. 회사는 회원이 서비스 이용의 장애로 인하여 발생한 회원의 부가적, 영업적인 손해에 대해서는 책임을 지지 않습니다.\n8. 회사의 책임은 물리적인 서비스 사용에 한하며, 특히 회원이 게시 또는 전송하거나 전송 받은 자료의 내용 및 가치에 대해서는 책임을 지지 않습니다.',
      },
      {
        title: '제53조(정보의 수집)',
        content:
          '1. 회사는 관련법령에 따라 회원이 전송한 메세지 정보 등을 일정기간 동안 저장•보관할 수 있습니다.\n2. 전1항의 정보는 회원의 분쟁조정, 민원처리 등 필요한 경우 또는 법령이 정한 경우에 한하여 회사, 회사의 업무를 위임 받아 처리하는 자 또는 법령으로 권한을 부여 받은 자만이 열람하거나 활용할 수 있습니다.\n3. 회사는 본 정보를 열람할 경우 열람이 필요한 사유 및 열람 범위를 해당 회원에게 사전 고지합니다. 단, 중대한 약관 위반행위 또는 법령 위반행위와 관련하여 통신 내용을 열람할 경우 사후 고지합니다.',
      },
      {
        title: '제54조 (준거법 및 재판관할)',
        content:
          '1. 회사와 회원 간 제기된 소송은 대한민국법을 준거법으로 합니다.\n2. 회사와 회원 간 발생한 분쟁에 관한 소송은 민사소송법상의 관할법원에 제소합니다.',
      },
    ],
  },
  {
    title: '부칙',
    sub: [
      {
        title: '',
        content: '1. 이 약관은 2016년 08월 12일부터 적용됩니다.',
      },
    ],
  },
];
const mobService = [
  {
    title: '제1장 총 칙',
    sub: [
      {
        title: '제1조 (목적)',
        content:
          '본 약관은 ㈜디엔에이클라우드 (이하 “회사”)가 제공하는 모바일 서비스의 이용에 대하여 “회사”와 회원(본 약관에 동의하고 회원등록을 완료한 서비스 이용자를 의미합니다. 이하 “회원”)과의 권리•의무 및 기타 필요한 사항을 규정함을 목적으로 합니다.',
      },
      {
        title: '제2조 (용어의 정의)',
        content:
          '본 약관에서 사용하는 용어의 정의는 다음과 같습니다.\n1. “인코딩 서비스”(Encoding Service)라 함은 회사가 회원의 컨텐츠를 모바일 서비스에 접합하도록 코덱을 변경해 주는 서비스를 의미합니다.\n2. “스트리밍 서비스”(Streaming Service)라 함은 회사가 회원의 모바일 컨텐츠를 이용하여 모바일 환경에서 멀티미디어 재생이 가능하도록 제공해주는 서비스를 의미합니다.\n3. “ASP 서비스”라 함은 회사가 회원에게 모바일서비스의 이용을 위한 서버와 네트워크 설비를 임대 및 관리하여 서비스를 하는 조건으로 회사가 회원에게 매월 일정액을 받는 서비스를 의미합니다.\n4. “트래픽”(파일 전송량)이라 함은 클라이언트 프로그램이 일정 시간 동안 서버로 데이터를 보내거나(Upload) 내려 받은(Download) 데이터를 의미하며, 단위로는 Mbyte/sec, Gbyte/sec 를 사용합니다.\n5. “이용계약”이라 함은 회사가 제공하는 서비스 이용과 관련하여 회사와 이용자 간에 체결하는 계약을 의미합니다.\n6. “서비스 이용요금”이라 함은 본 서비스 계약을 수행하기 위하여 회원에게 청구하는 회사의 제반 서비스 비용으로, 계약되어진 정규성 경비와 추가적인 트래픽 이용료, 서버의 설치, 기술지원 등 계약서 내에 규정되어 있지는 않으나 쌍방 합의에 의하여 수행되어진 추가적인 서비스 업무에 대한 실비기준의 비정규성 경비를 의미합니다.\n7. “ID”(아이디)라 함은 회원의 식별과 서비스 이용을 위하여 회원이 정하고 회사가 승인하는 문자와 숫자의 조합을 의미합니다.\n8. “비밀번호”라 함은 회원이 부여 받은 ID와 일치하는 회원임을 확인하고 비밀보호를 위해 회원 자신이 정한 문자 또는 숫자의 조합을 의미합니다.',
      },
      {
        title: '제3조 (약관의 효력 및 개정)',
        content:
          '1. 회사는 본 약관의 내용을 회원이 쉽게 알 수 있도록 서비스 초기 화면에 게시합니다.\n2. 본 약관의 적용기간은 고객의 가입일로부터 채권ㆍ채무가 완료되는 날까지로 규정합니다.\n3. 회사는 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제에 관한 법률, 소비자기본법 등 관련법을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.\n4. 회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 기존약관과 함께 그 적용일자 7일 전부터 적용일자 전일까지 공지합니다. 다만, 회원에게 불리한 약관의 개정의 경우에는 시행일로부터 30일 전 서비스 홈페이지에 공지하거나 회원이 회원이용신청 시 등록한 e-mail로 전송하는 방법으로 회원에게 통지합니다.\n5. 회사가 전항에 따라 회원에게 개정약관을 공지 또는 통지하면서 회원에게 약관시행일까지 의사표시를 하지 않으면 승인한 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 개정약관에 동의한 것으로 봅니다.\n6. 회원이 개정약관의 적용에 동의하지 않는 경우 회사는 개정약관의 내용을 적용할 수 없으며, 이 경우 회원은 이용계약을 해지 할 수 있습니다.',
      },
    ],
  },
  {
    title: '제2장 이용계약 체결 및 관리',
    sub: [
      {
        title: '제4조 (이용계약 체결)',
        content:
          '1. 회사가 제공하는 서비스를 이용하고자 하는 자가 본 약관을 읽고 동의를 한 다음 회사가 제시하는 양식과 절차에 따라 이용신청을 한 내용에 대해 회사가 승낙함으로써 회사와 서비스 이용자 간 이용계약이 체결됩니다. 단, 이용신청에 별도의 자료제출이 요청되는 경우에는 예외로 합니다.\n2. 회사는 다음 각호에 해당하는 신청에 대해서는 승낙을 하지 않거나 사후에 이용계약을 해제 또는 해지 할 수 있습니다.\n① 허위의 정보를 기재하거나 허위서류를 첨부하여 이용신청을 하는 경우\n② 회사가 제시하는 회원 이용신청 절차를 완료하지 않거나 본인확인이 불가능한 경우\n③ 이용신청을 하고 회사가 별도로 규정하는 기간 내에 회사가 별도로 요구하는 자료제출을 하지 않는 경우\n④ 회사의 서비스 제공을 저해하거나 타 회원의 서비스 이용에 지장을 줄 것으로 예상되는 경우\n⑤ 제3자의 신용카드, 유/무선 전화, 은행 계좌 등을 무단으로 이용 또는 도용하여 서비스 이용요금을 결제하는 경우\n⑥ 제25조에 의하여 회사로부터 계약해지를 당한 이후 1년이 경과하지 않은 경우\n⑦ 관련법령 등을 기준으로 하여 명백하게 사회질서 및 미풍양속에 반하는 위법행위를 할 목적으로 이용신청을 하는 경우\n⑧ 기타 회원의 자격을 부여하기에 곤란한 사유가 있는 경우\n3. 회사는 다음 각호에 해당하는 신청에 대해서는 승낙을 지연할 수 있습니다.\n① 회사의 설비에 여유가 없거나 기술적 장애가 있는 경우\n② 서비스 상의 장애 또는 서비스 이용요금 결제수단의 장애가 발생한 경우\n③ 기타 회사가 재정적, 기술적으로 필요하다고 인정하는 경우',
      },
      {
        title: '제5조 (회원의 ID등의 관리 의무)',
        content:
          '1. 회원은 서비스 이용을 위한 ID 및 비밀번호의 관리에 대한 책임, 본인 ID의 제3자에 의한 부정사용 등 회원의 고의•과실로 인해 발생하는 모든 불이익에 대한 책임을 부담합니다.\n2. 회원은 ID, 비밀번호 등을 도난 당하거나 제3자가 사용하고 있음을 인지한 경우에는 즉시 비밀번호를 수정하는 등의 조치를 취하여야 하며, 이를 회사에 통보하여 회사의 안내를 따라야 합니다.',
      },
      {
        title: '제6조 (회원정보의 변경)',
        content:
          '회원은 이용신청 시 기재한 사항이 변경되었을 경우 홈페이지 기재의 전화 및 e-mail로 회원정보의 수정을 요청하여야 하며, 변경하지 않음으로써 발생한 불이익에 대하여 회사는 책임을 지지 않습니다.',
      },
      {
        title: '제7조 (개인정보 수집)',
        content:
          '1. 회사는 적법하고 공정한 수단에 의하여 이용계약의 성립 및 이행에 필요한 최소한의 개인정보를 수집합니다.\n2. 회사는 개인정보의 수집 시 관련법규에 따라 개인정보취급방침에 그 수집범위 및 목적을 사전 고지합니다.',
      },
      {
        title: '제8조 (개인정보보호의무)',
        content:
          '회사는 정보통신망법 등 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및 회사의 개인정보처리방침이 적용됩니다.',
      },
      {
        title: '제9조 (불만처리)',
        content:
          '1. 회사는 개인정보와 관련하여 회원의 의견을 수렴하고 불만을 처리하기 위한 절차를 마련하여야 합니다.\n2. 회사는 전화, 전자우편 등을 통하여 회원의 불만사항을 접수, 처리 하여야 합니다.',
      },
      {
        title: '제10조 (회사의 의무)',
        content:
          '1. 회사는 관련법과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 서비스를 제공하기 위하여 노력합니다.\n2. 회사는 서비스 운영에 지장이 되는 장애가 발생했을 경우 이를 즉시 수리 또는 복구해야 하며, 안정적인 서비스 운영을 위해 최선을 다해야 합니다.\n3. 회사는 회원의 개인정보보호를 위하여 보안시스템을 갖추어야 하며 개인정보처리방침을 공시하고 준수합니다.\n4. 회사는 회원이 불법행위를 한 사실을 확인한 경우, 한국인터넷진흥원, 경찰청 등 관계기관에 관련 자료를 첨부하여 신고할 수 있습니다.\n5. 회사는 회원 중 고정 IP를 사용하는 개인 및 관리자 정보를 한국인터넷진흥원 등 인터넷주소관리기관에 최소한의 범위 내에서 제공할 수 있습니다.\n6. 회사는 회원으로부터 제기되는 의견이나 불만이 정당하다고 인정되는 경우에는 이를 즉시 처리합니다. 회원이 이용신청 시 기입한 전화나 e-mail로 처리과정 및 결과를 통보할 수 있습니다.',
      },
      {
        title: '제11조 (회원의 의무)',
        content:
          '1. 회원은 회사가 정한 서비스 이용요금을 지정된 일자에 납입할 의무가 있습니다.\n2. 회원은 회사가 제공하는 서비스를 이용함에 있어 다음 각 호에 해당하는 행위를 하여서는 안됩니다.\n① 이용신청이나 변경 시 타인의 정보 또는 허위내용을 등록하는 행위\n② 다른 회원의 ID 및 비밀번호를 도용하는 행위\n③ 회사 및 타인의 명예를 손상시키거나 업무를 방해하는 행위\n④ 다음 각목에 해당하는 정보 또는 컨텐츠를 전송, 도달, 유포하는 행위\n 가) 음란한 부호, 문언, 음향, 화상 또는 영상을 배포, 판매, 임대하거나 공연히 전시하는 내용의 정보\n 나) 사람을 비방할 목적으로 공연히 사실 또는 허위의 사실을 적시하여 타인의 명예를 훼손하는 내용의 정보\n 다) 공포심이나 불안감을 유발하는 부호, 문언, 음향, 화상 또는 영상을 반복적으로 상대방에게 도달하게 하는 내용의 정보\n 라) 정당한 사유 없이 정보통신시스템, 데이터 또는 프로그램 등을 훼손, 멸실, 변경, 위조하거나 그 운용을 방해하는 내용의 정보\n 마) 청소년보호법에 따른 청소년 유해 매체물로서 상대방의 연령 확인, 표시의무 등 법령에 따른 의무를 이행하지 아니하고 영리를 목적으로 제공하는 내용의 정보\n 바) 법령에 따라 금지되는 사행행위에 해당하는 내용의 정보\n 사) 법령에 따라 분류된 비밀 등 국가기밀을 누설하는 내용의 정보\n 아) 국가보안법에서 금지하는 행위를 수행하는 내용의 정보\n 자) 그 밖에 범죄를 목적으로 하거나 교사 또는 방조하는 내용의 정보\n 차) 타인의 지적재산권 또는 초상권 등 타인의 권리를 침해하는 내용의 정보\n 카) 기타 법령에 저촉되는 내용의 정보\n3. 회원은 자신의 웹사이트를 통하여 제공하는 정보의 저작권에 대하여 책임을 부담해야 합니다.\n4. 회원은 자신이 운영 중인 서비스의 데이터 등에 대해 별도로 저장할 의무가 있으며 외부 침입 등으로 인한 정보의 유출, 누락 또는 자료의 손실에 대해 회사는 책임을 지지 않습니다. 단, 회사가 해당 자료를 백업하여 별도로 보관 중인 경우에는 복구 시 도움을 줄 수 있으며, 백업자료가 없는 경우에는 회사는 책임을 지지 않습니다.\n5. 회원은 관련법 및 본 약관의 규정을 비롯하여 회사가 통지하는 사항 등을 준수하여야 합니다.',
      },
    ],
  },
  {
    title: '제3장 서비스의 이용',
    sub: [
      {
        title: '제12조 (서비스의 이용개시)',
        content:
          '1. 회사는 회원이 이용신청서에 기재한 서비스 개통 희망일에 맞추어 서비스를 개통합니다. 다만 회원 또는 회사의 업무일정과 서버 등의 장비 및 설비 현황에 따라 서비스 개통 예정일이 변경될 수 있습니다.\n2. 회사는 업무상 또는 기술상의 장애로 인하여 서비스를 개시하지 못하는 경우에는 회원에게 이를 통지합니다.\n3. 회원은 서비스 개통 예정일을 변경 또는 연기 하고자 하는 경우 개통 예정일로부터 최소 3일 전 회사에 통지하여야 하며, 변경 또는 연기된 개통 예정일이 최초 개통 예정일로부터 3일을 초과하는 경우, 회사는 자신의 판단으로 회원과 최초 협의한 장비 설치장소를 변경할 수 있습니다.',
      },
      {
        title: '제13조 (서버환경 지원 및 서비스 이전)',
        content:
          '1. 회사는 회원이 정상적으로 서비스를 이용할 수 있도록 최적의 서비스 환경을 지원해야 하며, 회원이 정해진 서비스 환경 외의 환경을 요청하는 경우에는 별도로 합의하여야 합니다.\n2. 회원이 ASP 서비스를 통해 인코딩서비스와 스트리밍 서비스를 이용시 변환된 컨텐츠의 이전은 불가합니다.',
      },
      {
        title: '제14조 (서비스의 제공)',
        content:
          '1. 회사는 회원에게 아래와 같은 서비스를 제공합니다.\n① 인코딩 서비스\n② 스트리밍 서비스\n③ 기타 회사가 추가 개발하거나 다른 회사와의 제휴계약 등을 통해 회원에게 제공할 일체의 서비스\n2. 제1항의 각 서비스 및 제휴 서비스의 내용은 변경 될 수 있으며, 이 경우 회사는 서비스 홈페이지에 공지하거나 회원이 이용신청 시 등록한 e-mail로 회원에게 통지 합니다.\n3. 서비스는 연중무휴 1일 24시간 제공함을 원칙으로 합니다.',
      },
      {
        title: '제15조 (인코딩 서비스의 이용)',
        content:
          '1. 회원은 회사에서 제공하는 인코딩 서비스의 구성에 맞추어 상호작업(이하 “연동”이라 합니다.) 을 수행합니다.\n2. 연동을 위해 회사는 회원에게 ID 및 비밀번호를 발급하며, 회원은 발급된 계정정보의 관리에 대한 책임과 본인 ID의 제3자에 의한 부정사용 등 회원의 고의•과실로 인해 발생하는 모든 불이익에 대한 책임을 부담합니다.\n3. 회사는 회원과 별도의 협의가 없는 경우 회원에게 일일 2,000개 이하의 컨텐츠인코딩을 지원합니다.\n4. 회원은 연동 서비스 이용간 아래 각호의 사항을 준수해야 합니다.\n① 회원은 연동된 회사소유 DB에 인코딩 작업 수행을 위한 정상적인 insert, select의 권한을 가지며, 기타 다른 작업을 수행할 수 없습니다. 회원 계정정보로 비정상적인 작업이 발생시 회사는 서비스를 중단할 수 있습니다.\n② 회원은 단일 파일의 용량 기준으로 4GB 이상의 파일에 대해서는 인코딩 작업을 요청할 수 없습니다.\n③ 회원은 회사의 아래 컨텐츠 변환 우선순위 정책에 의거 인코딩 작업의 우선순위를 책정해야 합니다.\n④ 하나의 게시물에 영상컨텐츠 파일 수가 12개를 초과하는 경우 인코딩요청은 거부 혹은 무시될 수 있습니다.\n⑤ 회사의 인코딩 서비스에 의해 변환된 컨텐츠는 회사가 지정한 위치에 저장되며, 회사와 협의하지 않는 한 회원이 원하는 임의의 위치에 저장할 수 없습니다.\n⑥ 회원의 컨텐츠가 회사의 인코딩서비스를 이용하여 변환 완료 후 회사의 스트리밍 서비스에 보관되는 경우, 변환된 컨텐츠의 보관주기는 2년으로, 회사는 변환된 컨텐츠의 보관주기를 초과하는 컨텐츠에 대해 오래된 컨텐츠를 우선으로 삭제대상 컨텐츠 목록을 회원에게 통보하며, 회원이 이의를 제기하지 않는다면 통보 후 1주일 뒤 통보된 컨텐츠의 삭제작업을 진행합니다.',
      },
      {
        title: '제16조 (스트리밍 서비스의 이용)',
        content:
          '1. 회사는 HTTP 혹은 RSTP의 2가지 방식 중 회원이 원하는 방식으로 24시간 무중단 서비스를 제공합니다.\n2. 서비스 대상 회원만을 대상으로 스트리밍 서비스를 제공하기 위해 인증 솔루션도 함께 제공하며, 인증솔루션은 회사에서 지정한 규격으로 구성해야 합니다.\n3. 회사는 회원의 서비스를 구분하기 위한 식별자로 company code를 발급하며, 회원은 회사로부터 발급받은 회원 본인의 company code를 이용해야 합니다.\n4. 스트리밍 서비스를 위한 컨텐츠의 총 저장용량은 회사와 별도의 협의가 없는 한 회원의 사이트별 50TB 이하로 구성하며, 50TB를 초과시 오래된 컨텐츠를 기준으로 삭제대상 컨텐츠 리스트를 회원에게 통보하며, 회원이 이의를 제기하지 않는다면 통보 후 1주일 뒤 통보된 컨텐츠의 삭제작업을 진행합니다.',
      },
    ],
  },
  {
    title: '제4장 서비스의 제한',
    sub: [
      {
        title: '제17조 (서비스의 중단)',
        content:
          '1. 회사는 회원에게 안정된 서비스를 제공하기 위하여 24시간 365일 서비스를 지속적으로 점검하여야 하며 이를 위하여 정기적, 비정기적 운영점검을 실시합니다. 그 내용은 다음 각 호와 같습니다.\n① 정기적 운영점검: 회사는 전체 네트워크 백본의 이상 유무를 점검하고, 전송효율을 높이기 위하여 주기별로 해당 점검일 오전 05시～07시 사이에 정기적 운영점검을 실시합니다.\n② 비정기적 운영점검: 회사는 전체 서비스의 품질 향상을 위해서나, 인코딩서비스 및 스트리밍 서비스를 구성하는 서버와 네트워크 장비들이 불특정 원인으로 인하여 오동작을 발생시킬 경우 문제점을 해결하기 위하여 비정기적 운영점검을 실시할 수 있습니다.\n2. 회사는 전항의 사유로 인해 점검간 서비스 중단이 불가결한 경우, 서비스 중단하기 이전에 회원의 계약서에 명시된 기술담당자에게 점검 관련 내용을 통보를 하도록 합니다.\n3. 회사가 1항에 의거, 점검내용을 공지 또는 통지하게 되면, 회원이 점검 전까지 명시적으로 거부 의사표시를 하지 아니한 경우 회원은 점검에 동의한 것으로 봅니다.\n4. 회사가 1항에 의거, 회원에게 서비스 중단 작업에 대한 통지를 하였을 경우 회원은 특별한 사유가 없는 한 작업을 승인해야 합니다.',
      },
      {
        title: '제18조 (서비스의 제한)',
        content:
          '1. 회사는 다음 각 호의 경우 1개월 이내의 기간을 정하여 회원의 서비스 이용을 제한하거나 중지시킬 수 있습니다.\n① 회원이 회사 서비스의 운영을 고의•과실로 방해하는 경우\n② 회원이 제11조 및 본 약관상의 의무를 위반하는 경우\n③ 회원이 바이러스 및 악성코드 유포 등 서비스 장애를 유발하는 행위를 한 경우\n④ 서비스를 범죄에 이용한다고 객관적으로 판단되는 경우\n⑤ 회원 서버가 해킹되었거나, 바이러스에 감염된 것으로 의심되는 경우\n⑥ 과도한 국제 회선 사용으로 인하여 기간통신사업자로부터 이의 해소를 요구 받은 경우\n⑦ 정부 기관이 증거 자료 확보를 이유로 적절한 법적 절차를 거쳐 운영 서버에 대한 일시적인 서비스 중지를 요청한 경우\n⑧ 회원이 회사의 허락 없이 서비스를 위해 제공된 포트(시스템에서 각각의 서비스를 구분하기 위해 사용되는 번호) 이외에 다른 포트를 점유하는 임의의 데몬(시스템에서 대기하면서 사용자의 요청에 대해 미리 지정된 규칙에 따라 응답 및 통신하기 위해 사용되는 프로그램)을 사용한 경우\n⑨ 회원이 회사로부터 발급받은 회원 본인의 company code외에 다른 code를사용한 경우\n2. 회원은 이용정지 시작일로부터 1개월 이내에 그 사유를 해소하여야 하며, 회사는 이용정지의 사유가 해소되면 즉시 서비스의 이용을 가능하게 합니다.\n3. 회사는 12개월 이상 서비스를 이용하지 아니하는 이용자의 개인정보를 보호하기 위해 서비스 이용 계약을 해지하거나 개인정보의 파기 등 필요한 조치를 할 수 있습니다.\n4. 회사는 휴면 계정 기간 만료 30일 전까지 개인정보가 파기되거나 분리되어 저장되는 사실과 기간 만료일 및 해당 개인정보의 항목을 전자우편, 서면, 모사전송, 전화 또는 유사한 방법 중 하나의 방법으로 이용자게 알리도록 합니다.\n5. 제3항에 따른 서비스 이용 계약의 해지의 삭제에 대한 책임은 회원이 부담하며, 회사는 고의 또는 과실이 없는 한 데이터 삭제에 따른 책임을 부담하지 않습니다.',
      },
      {
        title: '제19조 (서비스 초과 회원의 이용제한 및 해제 절차)',
        content:
          '1. 회사는 신청한 서비스를 초과(일일 인코딩 수, 용량 등)한 회원에 대해서 회사에 등록되어 있는 연락처로 이 사실을 통보하고, 회원은 최초 통보 받은 후 24시간 이내로 상위서비스로 신청하거나 초과부분의 원인제거를 통하여 현재의 서비스 허용량 이하로 조정해야 합니다.\n2. 회원이 제1항의 초과 통보를 받고도 전항의 의무를 이행하지 않는 경우에는 회사는 회원의 서비스 이용을 일시적으로 제한할 수 있으며, 회원이 이용제한 사유를 해소하는 경우에는 관련 절차에 따라 이용제한조치를 즉시 해제합니다.',
      },
      {
        title: '제20조 (서비스 유보)',
        content:
          '1. 회원이 일시적인 서비스 유보의 필요가 발생하여 이에 대한 요청이 있을 경우, 회사는 다음 각 호의 요건을 갖춘 회원에게 요청 기간 동안 서비스 제공을 일시 유보합니다.\n① 6개월 이상 서비스 중일 것\n② 요금 미납이 없을 것\n③ 유보 요청기간은 최대 30일 이하일 것\n④ 1년에 1회만 신청 가능\n⑤ 서비스 안정화 및 무료 사용기간이 없을 것\n2. 회사는 서비스가 유보된 회원에게 해당 유보 기간 중 기존에 회원이 납부하는 서비스 이용요금의 20%만 청구하며, 인터넷접속이용에 대한 비용은 청구하지 않습니다.\n3. 서비스 유보 기간이 경과하면 서비스는 정상적인 상태로 자동 복귀합니다.',
      },
      {
        title: '제21조 (권리의 귀속)',
        content:
          '1. 서비스에 대한 저작권 및 지적재산권은 회사에 귀속됩니다.\n2. 회원은 서비스에 관하여 사용권을 부여 받으며 이를 양도, 증여, 질권의 목적으로 사용할 수 없습니다.',
      },
    ],
  },
  {
    title: '제5장 서비스의 변경',
    sub: [
      {
        title: '제22조 (이용계약의 변경)',
        content:
          '1. 회원은 서비스 이용계약 내용 중 다음에 해당하는 변경 사유가 발생한 즉시 관련 절차에 따라 변경 신청해야 하며, 이와 관련한 정보 변경의 지연으로 인한 문제 발생 시 그 책임은 회원에게 있습니다.\n① 회원 및 사실상 요금 납입의 책임을 지기로 한 자의 상호, 성명 또는 주소의 변경\n② 계약 종류(상품의 종류, 이용계약기간, 이용목적) 의 변경\n③ 요금납부방식 및 결제계좌번호 변경\n④ 이용계약 기재의 담당자 정보(연락처 포함)\n2. 회원이 회사가 청구한 서비스 이용 요금을 체납하고 있는 경우, 회사는 변경 신청을 제한할 수 있습니다.\n3. 설비의 여유가 없거나, 기술상 서비스 제공이 어렵거나 회사의 서비스 정책이 변경되는 경우에 회사는 변경 신청을 제한할 수 있습니다.',
      },
      {
        title: '제23조 (이용계약의 갱신)',
        content:
          '이용계약기간 만료 30일전까지 회원과 회사 상호간에 별도의 의사표시가 없으면 이전의 계약 내용과 동일한 조건으로 계약이 갱신되는 것으로 봅니다.',
      },
      {
        title: '제24조 (회원의 계약의 해제 및 해지)',
        content:
          '1. 회원은 이용계약을 해지하고자 하는 경우, 최소 30 일 이전에 회사에 통보해야 하며, 회원이 원하는 해지 일자를 기준으로 미지불 서비스 이용 요금이 발생한 경우, 이에 대하여 지불을 완료하여야만 해지 절차가 마무리 됩니다.\n2. 기간에 대한 계약이 있는 경우, 회원의 귀책 사유로 인한 서비스 해지시 제29조에 의하여 위약금을 청구할 수 있습니다.',
      },
      {
        title: '제25조 (회사의 계약의 해제 및 해지)',
        content:
          '1. 회사는 회원이 본 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 명의도용, 저작권법을 위반한 불법프로그램의 사용 및 운영방해, 회사와 기타 제3자의 지적재산권에 대한 침해, 회사가 제공 또는 승인하지 아니한 컴퓨터 프로그램이나 기기 또는 장치를 제작•배포•이용•광고, 정보통신망법을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 계약을 해제 및 해지할 수 있습니다.\n2. 회사는 회원이 30일 이상 서비스 요금을 연체한 경우 직권으로 서비스를 정지할 수 있으며, 서비스 정지 후 5일 이내에 납입 불이행이 해결되지 않을 경우 직권으로 서비스를 해지할 수 있습니다. 다만, 회사가 특별히 승인한 경우에 한하여 최대 60일까지 서비스 정지일이 연장될 수 있습니다.\n3. 제18조에 따른 이용제한 또는 중지의 사유가 1년 이내에 재발한 경우 즉시 계약을 해제 및 해지할 수 있습니다.\n4. 제19조에 따른 해소요구에 대하여 적절한 조치가 없는 경우 즉시 계약을 해제 및 해지할 수 있습니다.\n5. 한국인터넷진흥원장이 스팸메일 등 불법행위의 전송사실을 확인하여 서비스 계약 해지를 요청하는 경우 즉시 계약을 해제 및 해지할 수 있습니다.\n6. 본 조에 따라 계약을 해제 및 해지하는 경우 회원의 e-mail 혹은 전화로 회원에게 통지합니다.',
      },
    ],
  },
  {
    title: '제6장 이용요금',
    sub: [
      {
        title: '제26조 (이용요금의 종류 및 계산방법)',
        content:
          '1. 서비스 이용과 관련하여 회원이 납입하여야 할 이용요금의 종류는 다음 각호와 같으며 그 이용요금의 세부내역은 별표 제1호 및 2호와 같습니다.\n① 설치비: 신규 서비스 개통 또는 서비스 이용 중에 재설치, 변경을 하는 경우에 지급하는 장비 공급 대금 또는 기술지원 이용 요금(신규 서비스 또는 설치변경 작업을 위하여 회원의 웹사이트 당 1 회만 지불하는 요금이며, 납부 후에는 환불되지 않습니다)\n② 서비스 이용요금: 서비스 종류별로 정해져 있는 기본요금\n③ 추가 이용요금: 서비스 기준 초과 또는 별도의 부가 서비스에 대한 이용요금\n2. 계약기간 중 회사에 의해 요금의 변동이 있을 경우 공시한 즉시 변경된 요금을 적용합니다. 단 회사와 회원의 합의가 있을 경우 합의 내용이 우선적으로 적용됩니다.\n3. 요금납부방법은 후납이며 일액, 월액으로 계산됩니다.\n4. 일 사용액의 계산은 0시부터 24시까지를 1일로 하는 것이며, 서비스 제공 개시일의 익일부터 계산합니다.\n5. 월 사용액 계산은 매월 1일부터 말일까지 해당월의 이용요금으로 하며 서비스 개통일, 변경일, 해지일이 당해 요금월의 중도인 경우에는 이용요금을 당해 월의 이용일수로 계산하는 일할 계산을 합니다. 이 경우 변경일은 변경일자부터 이용일수에 포함하여 계산합니다.\n6. 이용요금을 계산하는 경우에는 해당 요금월의 일수로 나눈 금액을 월액 요금의 일할로 산정합니다.\n7. 서비스 개설시의 설치비는 웹사이트당 1회에 한하여 청구하며 요금 청구 첫 번째 월 요금에 포함하여 청구합니다.',
      },
      {
        title: '제27조 (이용요금의 청구 및 납입)',
        content:
          '1. 회사는 이용요금납입을 위한 청구서를 매 사용월의 당월(종량제 서비스의 경우 서비스 사용월의 익월 발송) 중순경에 회원에게 발송하며, 회원은 청구서에 기재된 기일(공휴일인 경우 익일)까지 요금을 납입하여야 합니다.\n2. 회원이 국가기관, 지방자치단체, 주한 외국기관이거나 회사가 인정할 경우에는 중앙불(상급기관이나 주된 사업소 등에서 일괄하여 지불하는 것)로 납입할 수 있습니다.\n3. 단기이용요금은 서비스 이용을 1개월 미만으로 하는 회원(단기이용회원)이 납입하는 요금을 말하며, 이용요금은 신청 서비스의 규모 및 기간 등을 고려하여 회사와 회원 사이에 별도 협의를 거쳐 산정합니다.\n4. 회사는 서비스의 단기이용회원에게 이용요금 납입의 이행확보를 위하여 예치금을 납입하게 할 수 있습니다.\n5. 회사가 제공하는 서비스에 대한 이용요금은 계좌이체, 무통장입금의 방법으로 결제할 수 있습니다.\n6. 회원은 서비스에 대한 이용요금을 성실히 납부하여야 하며, 이용요금 납부의 지연 시에는 미납요금 총액의 2%의 가산금을 회사에 지급하여야 합니다.',
      },
      {
        title: '제28조 (이용요금의 환불 및 이의제기)',
        content:
          '1. 회사는 과오금이 발생한 경우 이용대금의 결제와 동일한 방법으로 과오금을 환불하여야 합니다. 다만, 동일한 방법으로 환불이 불가능한 경우에는 이를 사전에 고지합니다.\n2. 회원이 납부한 이용요금의 과납 또는 오납이 있을 경우 회사는 과오금을 환불하거나 발생 예정의 이용요금과 상계할 수 있습니다. 다만, 이용요금의 반환을 받아야 할 회원에게 요금 등의 체납이 있을 경우에는 반환하여야 할 금액에서 우선 공제할 수 있습니다.\n3. 회원은 이용대금에 대하여 이의를 제기할 수 있습니다. 단, 이용대금에 관한 이의는 그 사유 발생을 안 날로부터 1월, 그 사유가 발생한 날로부터 3월 이내에 제기하여야 합니다.\n4. 회사는 제3항의 이의신청 접수 후 2주 이내에 해당 이의신청의 타당성 여부를 조사하여 그 결과를 회원에게 통지합니다. 단, 부득이한 사유로 인하여 2주 이내에 해당 결과를 통지할 수 없는 경우에는 그 사유와 재 지정된 처리기한을 명시하여 회원에게 통지합니다.\n5. 본 조의 규정에 의한 환불은 환불 의무가 발생한 날로부터 3영업일 이내에 하는 것으로 하며 대금의 결제와 동일한 방법으로 이를 환급하여야 합니다. 다만, 동일한 방법으로 환불이 불가능할 때에는 이를 사전에 고지하여야 합니다.\n6. 환불에 소요되는 비용은 회원의 귀책사유로 인한 환불의 경우에는 회원이, 회사의 귀책사유로 인한 환불의 경우에는 회사가 각각 부담합니다.',
      },
      {
        title: '제29조 (위약금)',
        content:
          '1. 계약기간 만료 전 회원의 귀책사유로 해지하는 경우이거나 회원의 사정에 의해 해지하는 경우에는 다음에 해당하는 위약금을 회사에 납부하여야 합니다.\n① 잔여개월 이용요금의 50%에 해당하는 금액 (월 이용료 * 잔여개월 수 * 50/100)\n② 월 수 계산에서 1개월 기준 16일 이상 사용하였을 경우 1개월 사용한 것으로 간주합니다.\n2. 회원은 안정화 또는 무료 사용기간을 제공받은 경우, 제1항의 위약금에 안정화 또는 무료로 제공받은 서비스 내역을 금액으로 환산한 금액을 합하여 위약금으로 납부하여야 합니다.\n3. 제1항의 규정에도 불고하고 다음 각호의 경우 회원은 위약금 없이 계약을 해지할 수 있습니다.\n① 회사의 귀책사유로 월 고장누적시간이 72시간 이상 발생한 경우\n② 회사의 귀책사유로 1시간 이상의 고장이 월 5회 이상 발생한 경우',
      },
      {
        title: '제30조 (면탈요금의 징수)',
        content:
          '회사는 회원이 이 약관의 규정을 위배하여 서비스 이용요금을 면탈하는 행위를 한 경우 동 면탈한 금액의 2배에 해당하는 금액을 청구할 수 있습니다.',
      },
      {
        title: '제31조 (손해배상)',
        content:
          '1. 회사가 고의 또는 과실로 회원에게 손해를 발생시킨 경우, 손해에 대하여 배상할 책임이 있습니다.\n2. 회사는 회사의 명백한 귀책사유로 이용고객이 서비스를 이용하지 못하는 경우에는 이용고객이 그 사실을 회사에 통보하여 확인한 시점 (또는 그 전에 회사가 그 사실을 알았거나 알 수 있게 된 시점)부터 1시간 이상의 서비스제공 중지시간에 대하여 최근 3 개월 (3 개월 미만인 경우는 해당기간 적용) 의 1 일 평균요금을 24(시간) 로 나눈 수를 서비스 중지시간과 곱하여 산출한 금액의 3 배를 기준으로 하여 협의 후 배상합니다. 이 경우 단수가 1 시간 미만인 경우에는 1 시간으로 합니다.\n3. 회원이 본 약관을 위반하여 회사에 손해를 발생시킨 경우, 회원은 회사에 대하여 그 손해를 배상할 책임이 있습니다.\n4. 회원은 스팸메일 전송 등 불법행위를 하거나 전기통신사업법 등 관련 법령을 준수하지 못해 발생하는 모든 민형사상의 책임을 부담합니다.',
      },
    ],
  },
  {
    title: '부칙',
    sub: [
      {
        title: '',
        content:
          '1. 이 약관은 2016년 08월 12일부터 적용됩니다.\n' +
          '2. 이 약관에 명시되지 않은 사항은 회사의 IDC 이용약관을 따릅니다.',
      },
    ],
  },
];
const hosting = [
  {
    title: '제1장 총칙',
    sub: [
      {
        title: '제1조 (목적)',
        content:
          '본 약관은 ㈜디엔에이클라우드 (이하 “회사”)가 제공하는 호스팅서비스의 이용에 대하여 “회사”와 회원(본 약관에 동의하고 회원등록을 완료한 서비스 이용자를 의미합니다. 이하 “회원”)과의 권리•의무 및 기타 필요한 사항을 규정함을 목적으로 합니다.',
      },
      {
        title: '제2조 (용어의 정의)',
        content:
          '본 약관에서 사용하는 용어의 정의는 다음과 같습니다.\n1. “호스팅 서비스”(Hosting Service)라 함은 회사가 회원에게 서버 혹은 네트워크를 임대하고 인터넷을 이용한 서비스를 할 수 있도록 하며, 이를 관리하는 서비스를 의미합니다.\n2. “부가 서비스”라 함은 회원이 서비스를 이용하여 서버의 운영을 원활하게 하기 위하여 회사에서 기본으로 제공 서비스 이외의 제공되는 서비스를 의미합니다.\n3. “상면”또는 “랙”(Rack)이라 함은 회원의 서버 등의 장비를 보관하는 공간을 의미하며, 단위로는 U(Unit, 46mm 또는 1.6″ 기준), Rack(1/8, 1/4, 1/2, full), 평 (400/121 m2 )을 사용합니다.\n4. “트래픽”(파일 전송량)이라 함은 클라이언트 프로그램이 일정 시간 동안 서버로 데이터를 보내거나(Upload) 내려 받은(Download) 데이터를 의미하며, 단위로는 Mbyte, Gbyte 를 사용합니다.\n5. “대역”(Bandwidth)이라 함은 클라이언트 프로그램이 물리적인 회선을 이용할 때 데이터를 주고받기 위하여 실제로 점유하는 크기를 의미하며, 이의 측정은 사용한 트래픽 량을 일정 시간 단위로 이동 평균 그래프를 그리는 경우(Multi Router Traffic Grapher: MRTG) 의 폭으로 하며, 단위로는 Mbit/sec, Gbit/sec를 사용합니다.\n6. “이용계약”이라 함은 회사가 제공하는 서비스 이용과 관련하여 회사와 이용자 간에 체결하는 계약을 의미합니다.\n7. “서비스 이용요금”이라 함은 본 서비스 계약을 수행하기 위하여 회원에게 청구하는 회사의 제반 서비스 비용으로, 계약되어진 정규성 경비와 추가적인 트래픽 이용료, 서버의 설치, 기술지원 등 계약서 내에 규정되어 있지는 않으나 쌍방 합의에 의하여 수행되어진 추가적인 서비스 업무에 대한 실비기준의 비정규성 경비를 의미합니다.\n8. “ID”(아이디)라 함은 회원의 식별과 서비스 이용을 위하여 회원이 정하고 회사가 승인하는 문자와 숫자의 조합을 의미합니다.\n9. “비밀번호”라 함은 회원이 부여 받은 ID와 일치하는 회원임을 확인하고 비밀보호를 위해 회원 자신이 정한 문자 또는 숫자의 조합을 의미합니다.',
      },
      {
        title: '제3조 (약관의 게시와 개정)',
        content:
          '① 회사는 본 약관의 내용을 회원이 쉽게 알 수 있도록 서비스 초기 화면에 게시합니다.\n② 회사는 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제에 관한 법률, 소비자기본법 등 관련법을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.\n③ 회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 기존약관과 함께 그 적용일자 7일 전부터 적용일자 전일까지 공지합니다. 다만, 회원에게 불리한 약관의 개정의 경우에는 시행일로부터 30일 전 서비스 홈페이지에 공지하거나 회원이 회원이용신청 시 등록한 e-mail로 전송하는 방법으로 회원에게 통지합니다.\n④ 회사가 전항에 따라 회원에게 개정약관을 공지 또는 통지하면서 회원에게 약관시행일까지 의사표시를 하지 않으면 승인한 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 개정약관에 동의한 것으로 봅니다.\n⑤ 회원이 개정약관의 적용에 동의하지 않는 경우 회사는 개정약관의 내용을 적용할 수 없으며, 이 경우 회원은 이용계약을 해지 할 수 있습니다.',
      },
    ],
  },
  {
    title: '제2장 이용계약 체결 및 관리',
    sub: [
      {
        title: '제4조 (이용계약 체결)',
        content:
          '① 회사가 제공하는 서비스를 이용하고자 하는 자가 본 약관을 읽고 동의를 한 다음 회사가 제시하는 양식과 절차에 따라 이용신청을 한 내용에 대해 회사가 승낙함으로써 회사와 서비스 이용자 간 이용계약이 체결됩니다. 단, 이용신청에 별도의 자료제출이 요청되는 경우에는 예외로 합니다.\n② 회사는 다음 각호에 해당하는 신청에 대해서는 승낙을 하지 않거나 사후에 이용계약을 해제 또는 해지 할 수 있습니다.\n1. 허위의 정보를 기재하거나 허위서류를 첨부하여 이용신청을 하는 경우\n2. 회사가 제시하는 회원 이용신청 절차를 완료하지 않거나 본인확인이 불가능한 경우\n3. 이용신청을 하고 회사가 별도로 규정하는 기간 내에 회사가 별도로 요구하는 자료제출을 하지 않는 경우\n4. 회사의 서비스 제공을 저해하거나 타 회원의 서비스 이용에 지장을 줄 것으로 예상되는 경우\n5. 제3자의 신용카드, 유/무선 전화, 은행 계좌 등을 무단으로 이용 또는 도용하여 서비스 이용요금을 결제하는 경우\n6. 제27조에 의하여 회사로부터 계약해지를 당한 이후 1년이 경과하지 않은 경우\n7. 관련법령 등을 기준으로 하여 명백하게 사회질서 및 미풍양속에 반하는 위법행위를 할 목적으로 이용신청을 하는 경우\n8. 기타 회원의 자격을 부여하기에 곤란한 사유가 있는 경우\n③ 회사는 다음 각호에 해당하는 신청에 대해서는 승낙을 지연할 수 있습니다.\n1. 회사의 설비에 여유가 없거나 기술적 장애가 있는 경우\n2. 서비스 상의 장애 또는 서비스 이용요금 결제수단의 장애가 발생한 경우\n3. 기타 회사가 재정적, 기술적으로 필요하다고 인정하는 경우',
      },
      {
        title: '제5조 (회원의 ID등의 관리 의무)',
        content:
          '① 회원은 서비스 이용을 위한 ID 및 비밀번호의 관리에 대한 책임, 본인 ID의 제3자에 의한 부정사용 등 회원의 고의•과실로 인해 발생하는 모든 불이익에 대한 책임을 부담합니다.\n② 회원은 ID, 비밀번호 등을 도난 당하거나 제3자가 사용하고 있음을 인지한 경우에는 즉시 비밀번호를 수정하는 등의 조치를 취하여야 하며, 이를 회사에 통보하여 회사의 안내를 따라야 합니다.',
      },
      {
        title: '제6조 (회원정보의 변경)',
        content:
          '회원은 이용신청 시 기재한 사항이 변경되었을 경우 홈페이지 기재의 전화 및 e-mail로 회원정보의 수정을 요청하여야 하며, 변경하지 않음으로써 발생한 불이익에 대하여 회사는 책임을 지지 않습니다.',
      },
      {
        title: '제7조 (개인정보 수집)',
        content:
          '① 회사는 적법하고 공정한 수단에 의하여 이용계약의 성립 및 이행에 필요한 최소한의 개인정보를 수집합니다.\n② 회사는 개인정보의 수집 시 관련법규에 따라 개인정보처리방침에 그 수집범위 및 목적을 사전 고지합니다.',
      },
      {
        title: '제8조 (개인정보보호의무)',
        content:
          '회사는 정보통신망법 등 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및 회사의 개인정보취급방침이 적용됩니다.',
      },
      {
        title: '제9조 (불만처리)',
        content:
          '① 회사는 개인정보와 관련하여 회원의 의견을 수렴하고 불만을 처리하기 위한 절차를 마련하여야 합니다.\n② 회사는 전화, 전자우편 등을 통하여 회원의 불만사항을 접수, 처리 하여야 합니다.',
      },
      {
        title: '제10조 (회사의 의무)',
        content:
          '① 회사는 관련법과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 서비스를 제공하기 위하여 노력합니다.\n② 회사는 서비스 운영에 지장이 되는 장애가 발생했을 경우 이를 즉시 수리 또는 복구해야 하며, 안정적인 서비스 운영을 위해 최선을 다해야 합니다.\n③ 회사는 회원의 개인정보보호를 위하여 보안시스템을 갖추어야 하며 개인정보처리방침을 공시하고 준수합니다.\n④ 회사는 회원이 스팸메일 전송 등 불법행위를 한 사실을 확인한 경우, 한국인터넷진흥원, 경찰청 등 관계기관에 관련 자료를 첨부하여 신고할 수 있습니다.\n⑤ 회사는 회원 중 고정 IP를 사용하는 개인 및 관리자 정보를 한국인터넷진흥원 등 인터넷주소관리기관에 최소한의 범위 내에서 제공할 수 있습니다.\n⑥ 회사는 회원으로부터 제기되는 의견이나 불만이 정당하다고 인정되는 경우에는 이를 즉시 처리합니다. 회원이 이용신청 시 기입한 전화나 e-mail로 처리과정 및 결과를 통보할 수 있습니다.',
      },
      {
        title: '제11조 (회원의 의무)',
        content:
          '① 회원은 회사가 정한 서비스 이용요금을 지정된 일자에 납입할 의무가 있습니다.\n② 회원은 회사가 제공하는 서비스를 이용함에 있어 다음 각 호에 해당하는 행위를 하여서는 안됩니다.\n1. 이용신청이나 변경 시 타인의 정보 또는 허위내용을 등록하는 행위\n2. 다른 회원의 ID 및 비밀번호를 도용하는 행위\n3. 회사 및 타인의 명예를 손상시키거나 업무를 방해하는 행위\n4. 스팸메일을 전송하는 행위\n5. 다음 각목에 해당하는 정보 또는 컨텐츠를 전송, 도달, 유포하는 행위\n 가. 음란한 부호, 문언, 음향, 화상 또는 영상을 배포, 판매, 임대하거나 공연히 전시하는 내용의 정보\n 나. 사람을 비방할 목적으로 공연히 사실 또는 허위의 사실을 적시하여 타인의 명예를 훼손하는 내용의 정보\n 다. 공포심이나 불안감을 유발하는 부호, 문언, 음향, 화상 또는 영상을 반복적으로 상대방에게 도달하게 하는 내용의 정보\n 라. 정당한 사유 없이 정보통신시스템, 데이터 또는 프로그램 등을 훼손, 멸실, 변경, 위조하거나 그 운용을 방해하는 내용의 정보\n 마. 청소년보호법에 따른 청소년 유해 매체물로서 상대방의 연령 확인, 표시의무 등 법령에 따른 의무를 이행하지 아니하고 영리를 목적으로 제공하는 내용의 정보\n 바. 법령에 따라 금지되는 사행행위에 해당하는 내용의 정보\n 사. 법령에 따라 분류된 비밀 등 국가기밀을 누설하는 내용의 정보\n 아. 국가보안법에서 금지하는 행위를 수행하는 내용의 정보\n 자. 그 밖에 범죄를 목적으로 하거나 교사 또는 방조하는 내용의 정보\n 차. 타인의 지적재산권 또는 초상권 등 타인의 권리를 침해하는 내용의 정보\n 카. 기타 법령에 저촉되는 내용의 정보\n③ 회원은 자신의 웹사이트를 통하여 제공하는 정보의 저작권에 대하여 책임을 부담해야 합니다.\n④ 회원은 자신이 운영 중인 서버가 인가 받지 않은 침입자로부터 안전하게 보호받을 수 있도록 시스템 운영과 관련한 정기적인 보안 업데이트를 하여야 하며, 별도로 시스템 보안 서비스와 관련한 계약을 회사와 체결한 경우를 제외하고는 발생한 보안 사고에 대하여 회사는 책임을 지지 아니합니다.\n⑤ 장비에 대한 소유권이 있는 회원은 서비스 해지 시 해당장비를 즉시 반출해야 하며 회사는 회원 장비를 보관할 의무가 없습니다. 서비스 해지 후 회사가 해당장비를 보유함에 따라 발행하는 비용을 회원에게 청구할 수 있습니다.\n⑥ 회원은 자신이 운영 중인 서비스의 데이터 등에 대해 별도로 저장할 의무가 있으며 외부 침입 등으로 인한 정보의 유출, 누락 또는 자료의 손실에 대해 회사는 책임을 지지 않습니다.\n⑦ 회원은 임의로 장비의 개조 및 장소이동을 할 수 없습니다.\n⑧ 회원은 회사로부터 제공받은 설비, 계정 및 소프트웨어 등을 망실 또는 훼손하거나 장애를 초래한 경우에는 그 보충, 수선 또는 기타 공사에 소요되는 비용을 부담하여야 합니다.\n⑨ 회원은 관련법 및 본 약관의 규정을 비롯하여 회사가 통지하는 사항 등을 준수하여야 합니다.',
      },
    ],
  },
  {
    title: '제3장 서비스의 이용',
    sub: [
      {
        title: '제12조 (서비스의 이용개시)',
        content:
          '① 회사는 회원이 이용신청서에 기재한 서비스 개통 희망일에 맞추어 서비스를 개통합니다. 다만, 회사의 업무일정과 서버 등의 장비 및 설비 현황에 따라 서비스 개통 예정일이 변경될 수 있습니다.\n② 회사는 업무상 또는 기술상의 장애로 인하여 서비스를 개시하지 못하는 경우에는 회원에게 이를 통지합니다.\n③ 회원은 서비스 개통 예정일을 변경 또는 연기하고자 하는 경우 개통 예정일로부터 최소 3일 전 회사에 통지하여야 하며, 변경 또는 연기된 개통 예정일이 최초 개통 예정일로부터 3일을 초과하는 경우, 회사는 자신의 판단으로 회원과 최초 협의한 장비 설치장소를 변경할 수 있습니다.',
      },
      {
        title: '제13조 (서버환경 지원 및 서비스 이전)',
        content:
          '① 회사는 회원이 정상적으로 서비스를 이용할 수 있도록 최적의 서버환경을 지원해야 하며, 회원이 특별한 서버환경을 요청하는 경우에는 별도로 합의하여야 합니다.\n② 회원이 서비스를 타사로 이전하는 경우 네임서버의 캐시(cache) 등으로 인하여 회사의 과실 없이 접속이 1~2일 정도 중단되더라도 이는 인터넷 환경의 특성이므로 회사는 이에 대한 책임을 지지 아니합니다. 또한 이전과 관련하여 기존에 사용하는 파일의 이전과 권한 설정작업은 회원이 직접 하여야 합니다.',
      },
      {
        title: '제14조 (서비스의 제공)',
        content:
          '① 회사는 회원에게 아래와 같은 서비스를 제공합니다.\n1. 호스팅 서비스(임대형)\n2. 호스팅 서비스(소유권 이전형)\n② 제1항의 각 서비스 및 제휴 서비스의 내용은 변경될 수 있으며, 이 경우 회사는 서비스 홈페이지에 공지하거나 회원이 이용신청 시 등록한 e-mail로 회원에게 통지합니다.\n③ 서비스는 연중무휴 1일 24시간 제공함을 원칙으로 합니다.',
      },
      {
        title: '제15조 (서비스의 이용)',
        content:
          '① 회원은 회사로부터 장비를 임대 혹은 일정기간 사용 후 소유권 이전을 전제로 임대하는 호스팅 서비스를 이용할 수 있으며, 매월 장비 임대료를 납부해야 합니다.\n② 임대한 장비가 서비스 이용에 문제가 있을 경우 회사에 장비의 교체를 요청할 수 있으며 회사는 이에 즉각 응하여야 합니다. 단, 회원의 귀책 사유에 의한 망실의 경우 수리비용을 부담한 뒤 수리 후에 이용하여야 합니다.\n③ 기간 계약을 한 임대 장비의 경우, 회사의 귀책 사유로 인한 해지의 사유를 제외하고, 계약 기간 이전에 이를 해약 시 제32조에서 정한 해지 위약금을 납입하여야 합니다.\n④ 1회 이상 임대 비용이 연체된 경우, 회사는 이에 대한 납부 또는 임대장비 반납을 통보하며, 5일 이상 이의 납부가 이루어지지 않을 경우, 임대 장비를 강제 반납시킬 수 있습니다.\n⑤ 회원에게 임대한 서버는 반납 이전에 서버 운영과 관련한 데이터를 백업 받아야 하며, 반납 절차 종료 후 시스템은 임의 포맷 환수되며, 이와 관련한 데이터의 망실 시 회사에 어떠한 피해 책임도 물을 수 없습니다.',
      },
    ],
  },
  {
    title: '제4장 서비스의 제한',
    sub: [
      {
        title: '제16조 (서비스의 중단)',
        content:
          '① 회사는 회원에게 안정된 서비스를 제공하기 위하여 24시간 365일 전체 네트워크를 점검하여야 하며 이를 위하여 정기적, 비정기적 운영점검을 실시합니다. 그 내용은 다음 각 호와 같습니다.\n1. 정기적 운영점검: 회사는 전체 네트워크 백본의 이상 유무를 점검하고, 전송효율을 높이기 위하여 주기별로 해당 점검일 오전 05시～07시 사이에 정기적 운영점검을 실시하며, 관련 내용을 사전에 회원에게 통보합니다.\n2. 비정기적 운영점검: 회사는 전체 네트워크 백본의 효율을 높이거나, 네트워크가 불특정 원인으로 인하여 오동작을 발생시킬 경우나, 회원 내부 네트워크의 문제점을 해결하기 위하여 비정기적 운영점검을 실시할 수 있습니다.',
      },
      {
        title: '제17조 (서비스의 제한)',
        content:
          '① 회사는 다음 각 호의 경우 1개월 이내의 기간을 정하여 회원의 서비스 이용을 제한하거나 중지시킬 수 있습니다.\n1. 회원이 회사 서비스의 운영을 고의•과실로 방해하는 경우\n2. 회원이 제11조 및 본 약관상의 의무를 위반하는 경우\n3. 회원이 스팸메일을 전송하거나 바이러스 유포, 기타 네트워크 장애를 유발하는 행위를 한 경우\n4. 스팸릴레이로 이용되거나 웜에 감염되어 스팸메일을 전송한 경우\n5. 서비스를 범죄에 이용한다고 객관적으로 판단되는 경우\n6. 회원 서버가 이용계약 체결에 따른 네트워크 대역을 초과하여 사용하는 경우\n7. 회원 서버가 해킹되었거나, 바이러스에 감염된 것으로 의심되는 경우\n8. 회원 서버가 과다한 전기를 사용하거나 발열로 인하여 회사의 서비스 운영에 지장이 발생될 것으로 예상되는 경우\n9. 과도한 국제 회선 사용으로 인하여 기간통신사업자로부터 이의 해소를 요구 받은 경우\n10. 정부 기관이 증거 자료 확보를 이유로 적절한 법적 절차를 거쳐 운영 서버에 대한 일시적인 서비스 중지를 요청한 경우\n11. 방송통신위원회, 미래창조과학부 또는 한국인터넷진흥원 등 관련 기관이 스팸메일 등 불법행위의 전송 사실을 확인하여 이용정지를 요청하는 경우\n12. 회원이 회사의 허락 없이 기본 포트(telnet, FTP, web 등) 이외 다른 포트(시스템에서 각각의 서비스를 구분하기 위해 사용되는 번호)를 점유하는 임의의 데몬(시스템에서 대기하면서 사용자의 요청에 대해 미리 지정된 규칙에 따라 응답 및 통신하기 위해 사용되는 프로그램)을 사용한 경우\n② 회원은 이용정지 시작일로부터 1개월 이내에 그 사유를 해소하여야 하며, 회사는 이용정지의 사유가 해소되면 즉시 서비스의 이용을 가능하게 합니다.\n③ 회사는 12개월 이상 서비스를 이용하지 아니하는 이용자의 개인정보를 보호하기 위해 서비스 이용 계약을 해지하거나 개인정보의 파기 등 필요한 조치를 할 수 있습니다.\n④ 회사는 휴면 계정 기간 만료 30일 전까지 개인정보가 파기되거나 분리되어 저장되는 사실과 기간 만료일 및 해당 개인정보의 항목을 전자우편, 서면, 모사전송, 전화 또는 유사한 방법 중 하나의 방법으로 이용자게 알리도록 합니다.\n⑤ 제3항에 따른 서비스 이용 계약의 해지의 삭제에 대한 책임은 회원이 부담하며, 회사는 고의 또는 과실이 없는 한 데이터 삭제에 따른 책임을 부담하지 않습니다.',
      },
      {
        title: '제18조 (서비스 초과 회원의 이용제한 및 해제 절차)',
        content:
          '① 회사는 신청한 서비스를 초과(트래픽, 용량 등)한 회원에 대해서 회사에 등록되어 있는 연락처로 이 사실을 통보하고, 회원은 최초 통보 받은 후 24시간 이내로 상위서비스로 신청하거나 초과부분의 원인제거를 통하여 현재의 서비스 허용량 이하로 조정해야 합니다.\n② 회원이 제1항의 초과 통보를 받고도 전항의 의무를 이행하지 않는 경우에는 회사는 회원의 서비스 이용을 일시적으로 제한할 수 있으며, 회원이 이용제한 사유를 해소하는 경우에는 관련 절차에 따라 이용제한조치를 즉시 해제합니다.',
      },
      {
        title: '제19조 (서버의 고장 수리)',
        content:
          '① 회사는 현장 유지 보수가 가능하도록 장비의 처음 이용일로부터 1년간은 동종 또는 유사 사양의 대체 장비를 보유할 의무를 가집니다.\n② 전1항 장비의 고장 수리는 회사의 소재지와 회사가 이용하는 IDC에서만 제공합니다.\n③ 회원이 임대 혹은 소유권 이전받은 장비에 대한 무상 수리 보증 기간은 장비의 처음 이용일을 기준으로 1년이며, 이후 발생한 수리의 경우 유상으로 처리를 기본으로 합니다. 단, 1년이 경과하더라도 서버 생산 판매 업체가 무상 고장 수리를 해 줄 수 있는 경우는 무상으로 처리합니다.\n④ 무상 수리 보증 기간내의 제품이라 할지라도 회원의 과실로 인한 파손 및 손상이 있을 경우 유상으로 처리되며, 소모품 또는 마모성 부품은 제품의 보증기간과 관계없이 유상으로 처리합니다.\n⑤ 회원은 데이터 저장 장치의 장애에 대비하여 자신의 서버에 대한 주기적인 데이터 백업을 하여야 하며 회사는 데이터 저장 장치의 장애로 인한 데이터 소실에 책임을 지지 않습니다.\n⑥ 회사에서 제공하지 않은 장비의 고장에 대하여는 회사는 책임을 지지 아니합니다.',
      },
      {
        title: '제20조 (서비스 이용 중 장비의 반출)',
        content:
          '① 임대 장비의 경우 IDC 밖으로의 반출이 불가능하며, 회원이 필요에 의해 반출을 원할 경우 서버 구매 금액만큼을 보증금으로 입금한 후에 반출할 수 있으며, 반납 시 보증금은 환불됩니다.\n② 소유권 이전형 호스팅 서비스를 이용하는 회원은 장비를 IDC 외부로 반출하기 위해서는 소유권 이전 계약에 따른 잔여 서비스 이용료를 선지급해야 합니다.\n③ 위 사항을 제외하고 소유권 이전 되지 않은 상태에서 장비의 반출은 불가합니다.',
      },
      {
        title: '제21조 (IDC 출입)',
        content:
          '① 회원은 IDC 방문을 원할 경우 IDC인터넷 홈페이지(www.dnacloud.co.kr) 또는 전화로 사전예약을 하여야 합니다.\n② IDC 출입은 예약확인 절차를 거쳐 출입증을 발급 받은 후 가능하며, 수시로 출입하는 시스템 담당자는 회사로부터 사전 출입권한을 부여 받아 출입절차를 간소화 할 수 있습니다.\n③ 회원이 출입권한을 받아 IDC에 출입 시 반드시 허가된 구역만을 접근하여야 합니다.\n④ 회원은 회원장비 이외에는 어떠한 시설에도 접근하여서는 안됩니다.',
      },
      {
        title: '제22조 (정보의 제공)',
        content:
          '회사는 회원이 서비스 이용 중 필요하다고 인정되는 경우 다양한 정보를 공지사항이나 e-mail 등의 방법으로 회원에게 제공할 수 있습니다. 다만, 회원은 관련법에 따른 거래관련 정보 및 회원문의 등에 대한 답변 등을 제외하고는 언제든지 e-mail에 대해서 수신 거절을 할 수 있습니다.',
      },
      {
        title: '제23조 (권리의 귀속)',
        content:
          '① 서비스에 대한 저작권 및 지적재산권은 회사에 귀속됩니다.\n② 회원은 서비스에 관하여 사용권을 부여 받으며 이를 양도, 증여, 질권의 목적으로 사용할 수 없습니다.',
      },
    ],
  },
  {
    title: '제5장 서비스의 변경',
    sub: [
      {
        title: '제24조 (이용계약의 변경)',
        content:
          '① 회원은 서비스 이용계약 내용 중 다음에 해당하는 변경 사유가 발생한 즉시 관련 절차에 따라 변경 신청해야 하며, 이와 관련한 정보 변경의 지연으로 인한 문제 발생 시 그 책임은 회원에게 있습니다. 1. 회원 및 사실상 요금 납입의 책임을 지기로 한 자의 상호, 성명 또는 주소의 변경 2. 계약 종류(상품의 종류, 회선의 종류, 접속 회선의 대역, 이용계약기간, 이용목적) 의 변경 3. 요금납부방식 및 결제계좌번호 변경 4. 이용계약 기재의 담당자 정보(연락처 포함) ② 회원이 회사가 청구한 서비스 이용 요금을 체납하고 있는 경우, 회사는 변경 신청을 제한할 수 있습니다. ③ 설비의 여유가 없거나, 기술상 서비스 제공이 어렵거나 회사의 서비스 정책이 변경되는 경우에 회사는 변경 신청을 제한할 수 있습니다.',
      },
      {
        title: '제25조 (이용계약의 갱신)',
        content:
          '이용계약기간 만료 30일전까지 회원과 회사 상호간에 별도의 의사표시가 없으면 이전의 계약 내용과 동일한 조건으로 계약이 갱신되는 것으로 봅니다.',
      },
      {
        title: '제26조 (회원의 계약의 해제 및 해지)',
        content:
          '① 회원은 이용계약을 해지하고자 하는 경우, 최소 30 일 이전에 회사에 통보해야 하며, 회원이 원하는 해지 일자를 기준으로 미지불 서비스 이용 요금이 발생한 경우, 이에 대하여 지불을 완료하여야만 해지 절차가 마무리 됩니다. ② 서버호스팅 계약을 중도 해지하는 경우에 회원은 회사에게 제 32조에 의하여 위약금을 청구할 수 있습니다.',
      },
      {
        title: '제27조 (회사의 계약의 해제 및 해지)',
        content:
          '① 회사는 회원이 본 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 명의도용, 저작권법을 위반한 불법프로그램의 사용 및 운영방해, 회사와 기타 제3자의 지적재산권에 대한 침해, 회사가 제공 또는 승인하지 아니한 컴퓨터 프로그램이나 기기 또는 장치를 제작•배포•이용•광고, 정보통신망법을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 계약을 해제 및 해지할 수 있습니다. ② 회사는 회원이 1회 이상 서비스 요금을 연체한 경우 직권으로 서비스를 정지할 수 있습니다. 서비스 정지 후 5일 이내에 납입 불이행이 해결되지 않을 경우 회사는 직권으로 서비스를 해지할 수 있으며, 회원은 장비와 그에 포함된 데이터에 대한 모든 권리를 상실합니다. ③ 서버에 대한 소유권이 회원에게 있는 경우 연체가 발생한 시점을 기준으로 최장3개월 이내에 연체 비용을 납부하고 해당 장비를 반출해야 합니다. 연체가 발생한 시점을 기준으로 3개월 경과 후에도 해당 장비를 반출하지 않을 시 회사는 회원이 서버 소유권을 포기한 것으로 판단하여 데이터를 삭제하고 해당장비를 폐기할 수 있습니다. 이 경우 회원은 회사에 데이터 삭제 및 해당장비 폐기에 대해 어떠한 책임도 물을 수 없습니다. 단, 회사는 회원에게 SMS, 메일, 전화 또는 회사 홈페이지의 공지사항을 등을 통해 해당장비의 폐기 일정을 폐기 전에 알립니다. ④ 제17조에 따른 이용제한 또는 중지의 사유가 1년 이내에 재발한 경우 즉시 계약을 해제 및 해지할 수 있습니다. ⑤ 제18조에 따른 해소요구에 대하여 적절한 조치가 없는 경우 즉시 계약을 해제 및 해지할 수 있습니다. ⑥ 한국인터넷진흥원장이 스팸메일 등 불법행위의 전송사실을 확인하여 서비스 계약 해지를 요청하는 경우 즉시 계약을 해제 및 해지할 수 있습니다. ⑦ 본 조에 따라 계약을 해제 및 해지하는 경우 회원의 e-mail 혹은 전화로 회원에게 통지합니다.',
      },
      {
        title: '제28조 (계약 해지 회원 소유 장비의 처리)',
        content:
          '① 이용계약 해지 시 회원은 해지일부터 기산하여 5일이내 회사의 IDC에서 회원소유의 장비를 반출하여야 하며, 제20조와 동일한 절차에 의하여 반출합니다. ② 회원은 제1항의 기한을 초과하여 장비를 반출하는 경우, 해지일부터 장비의 실제 반출일까지 장비의 보관에 대한 대가로서, 기존 이용계약에 따른 서비스 이용요금을 일할 계산하여 회사에 지불하여야 합니다. ③ 서버의 반출 시 회원의 직접 반출을 원칙으로 하며, 회원이 사정에 의하여 택배나 대행 업체를 이용한 발송을 요청하는 경우 발송으로 인한 분실 또는 파손에 대하여 회사는 책임지지 않습니다. ④ 제1항의 기한 내에 장비를 반출하지 않는 경우, 회원에게 e-mail 또는 전화로 장비의 반출을 요청하며, 회원은 회사의 요청으로부터 24시간 이내 적절한 조치를 취하여야 합니다. 회사는 전단의 시한 내에 회원이 적절한 조치를 취하지 않을 경우 즉시 회원의 장비를 회사가 지정한 장소로 반출 및 이동할 수 있습니다. ⑤ 회사는 제4항에도 불구하고 회사가 1개월 이상 회원의 장비를 보관하게 되는 경우, 회사는 다시 1개월 이상의 기간을 정하여 회원에게 데이터 백업의 요청, 장비의 반출 및 임의처분 예정에 대하여 최고합니다. 회원이 최고한 기간까지 장비를 반출하지 않는 경우, 회사는 회원이 미납한 이용요금, 위약금, 반출일까지 장비 보관비용 등의 충당을 위하여 회원의 장비를 임의처분(경매, 임의매각 등) 할 수 있으며, 이와 관련하여 회원은 회사에 자신이 데이터 백업 조치를 하지 않아 발생한 책임 및 장비 반환 책임을 물을 수 없습니다. ⑥ 회사는 제5항의 임의처분에도 불구하고 회원이 미납한 비용을 온전히 충당하지 못하는 경우, 회원에게 미충당된 비용의 납부를 청구합니다. 회원은 회사의 청구일로부터 15일 이내 해당 비용을 납부하여야 합니다. ⑦ 회사는 제4항 및 제5항에 의한 장비의 반출 중 자신의 중과실 및 고의에 의해 발생한 손해를 제외하고, 회원이 제6조 및 제24조1항의 의무를 게을리하여 발생한 손해에 대하여 일체의 책임을 부담하지 않습니다. ⑧ 회원이 서비스 이용계약 해지 후 재사용할 경우 각 회사의 IP 사용기준에 따라서 변경된 IP 를 할당 받을 수 있으며 서버의 위치 또한 변경되어 서비스 재개될 수 있습니다. 또한 해지된 후 이에 대한 재사용을 원하는 경우 회원은 다시 신규 서비스 신청을 하여야 하며 이에 따라 신규 설치비가 부과될 수 있습니다.',
      },
    ],
  },
  {
    title: '제6장 이용요금',
    sub: [
      {
        title: '제29조 (이용요금의 종류 및 계산방법)',
        content:
          '① 서비스 이용과 관련하여 회원이 납입하여야 할 이용요금의 종류는 다음 각호와 같습니다.\n1. 설치비: 신규 서비스 개통 또는 서비스 이용 중에 재설치, 변경을 하는 경우에 지급하는 장비 공급 대금 또는 기술지원 이용 요금(신규 서비스 또는 설치변경 작업을 위하여 1 회만 지불하는 요금이며, 납부 후에는 환불되지 않습니다)\n2. 서비스 이용요금: 서비스 종류별로 정해져 있는 기본요금\n3. 추가 이용요금: 서비스 기준 초과 또는 별도의 부가 서비스에 대한 이용요금\n② 계약기간 중 회사에 의해 요금의 변동이 있을 경우 공시한 후 익월부터 변경된 요금을 적용합니다. 단 회사와 회원의 합의가 있을 경우 합의 내용이 우선적으로 적용됩니다.\n③ 회원은 서비스 개설시 3개월 이용료를 선납해야하며, 선납한 이용료는 계약 종료 기간 전 3개월간 이용료로 충당합니다.\n④ 요금납부방법은 선납이며 일액, 월액으로 계산됩니다.\n⑤ 일 사용액의 계산은 0시부터 24시까지를 1일로 하는 것이며, 서비스 제공 개시일의 익일부터 계산합니다.\n⑥ 월 사용액 계산은 매월 1일부터 말일까지 해당월의 이용요금으로 하며 서비스 개통일, 변경일, 해지일이 당해 요금월의 중도인 경우에는 이용요금을 당해 월의 이용일수로 계산하는 일할 계산을 합니다. 이 경우 변경일은 변경일자부터 이용일수에 포함하여 계산합니다.\n⑦ 이용요금을 계산하는 경우에는 해당 요금월의 일수로 나눈 금액을 월액 요금의 일할로 산정합니다.\n⑧ 서비스 개설시의 설치비는 1회에 한하여 청구하며 요금 청구 첫 번째 월 요금에 포함하여 청구합니다.',
      },
      {
        title: '제30조 (이용요금의 청구 및 납입)',
        content:
          '① 회사는 이용요금납입을 위한 청구서를 매 사용월의 당월중순경에 회원에게 발송하며, 회원은 청구서에 기재된 기일(공휴일인 경우 익일)까지 요금을 납입하여야 합니다.\n② 회원이 국가기관, 지방자치단체, 주한 외국기관이거나 회사가 인정할 경우에는 중앙불(상급기관이나 주된 사업소 등에서 일괄하여 지불하는 것)로 납입할 수 있습니다.\n③ 단기이용요금은 서비스 이용을 1개월 미만으로 하는 회원(단기이용회원)이 납입하는 요금을 말하며, 이용요금은 신청 서비스의 규모 및 기간 등을 고려하여 회사와 회원 사이에 별도 협의를 거쳐 산정합니다.\n④ 회사는 서비스의 단기이용회원에게 이용요금 납입의 이행확보를 위하여 예치금을 납입하게 할 수 있습니다.\n⑤ 회사가 제공하는 서비스에 대한 이용요금은 계좌이체, 무통장입금의 방법으로 결제할 수 있습니다.\n⑥ 회원은 서비스에 대한 이용요금을 성실히 납부하여야 하며, 이용요금 납부의 지연 시에는 미납요금 총액의 2%의 가산금을 회사에 지급하여야 합니다.',
      },
      {
        title: '제31조 (이용요금의 환불 및 이의제기)',
        content:
          '① 회사는 과오금이 발생한 경우 이용대금의 결제와 동일한 방법으로 과오금을 환불하여야 합니다. 다만, 동일한 방법으로 환불이 불가능한 경우에는 이를 사전에 고지합니다.\n② 회원이 납부한 이용요금의 과납 또는 오납이 있을 경우 회사는 과오금을 환불하거나 발생 예정의 이용요금과 상계할 수 있습니다. 다만, 이용요금의 반환을 받아야 할 회원에게 요금 등의 체납이 있을 경우에는 반환하여야 할 금액에서 우선 공제할 수 있습니다.\n③ 회원은 이용대금에 대하여 이의를 제기할 수 있습니다. 단, 이용대금에 관한 이의는 그 사유 발생을 안 날로부터 1월, 그 사유가 발생한 날로부터 3월 이내에 제기하여야 합니다.\n④ 회사는 제3항의 이의신청 접수 후 2주 이내에 해당 이의신청의 타당성 여부를 조사하여 그 결과를 회원에게 통지합니다. 단, 부득이한 사유로 인하여 2주 이내에 해당 결과를 통지할 수 없는 경우에는 그 사유와 재 지정된 처리기한을 명시하여 회원에게 통지합니다.\n⑤ 본 조의 규정에 의한 환불은 환불 의무가 발생한 날로부터 3영업일 이내에 하는 것으로 하며 대금의 결제와 동일한 방법으로 이를 환급하여야 합니다. 다만, 동일한 방법으로 환불이 불가능할 때에는 이를 사전에 고지하여야 합니다.\n⑥ 환불에 소요되는 비용은 회원의 귀책사유로 인한 환불의 경우에는 회원이, 회사의 귀책사유로 인한 환불의 경우에는 회사가 각각 부담합니다.',
      },
      {
        title: '제32조 (위약금)',
        content:
          '① 계약기간 만료 전 회원의 귀책사유로 해지하는 경우이거나 회원의 사정에 의해 해지하는 경우에는 다음에 해당하는 위약금을 회사에 납부하여야 합니다.\n1. 잔여개월 이용요금의 50%에 해당하는 금액 (월 이용료 * 잔여개월 수 * 50/100)\n2. 월 수 계산에서 1개월 기준 16일 이상 사용하였을 경우 1개월 사용한 것으로 간주합니다.\n② 회원은 안정화 또는 무료 사용기간을 제공받은 경우, 제1항의 위약금에 안정화 또는 무료로 제공받은 서비스 내역을 금액으로 환산한 금액을 합하여 위약금으로 납부하여야 합니다.\n③ 제1항의 규정에도 불구하고 다음 각호의 경우 회원은 위약금 없이 계약을 해지할 수 있습니다.\n1. 회사의 귀책사유로 월 고장누적시간이 72시간 이상 발생한 경우\n2. 회사의 귀책사유로 1시간 이상의 고장이 월 5회 이상 발생한 경우',
      },
      {
        title: '제33조 (면탈요금의 징수)',
        content:
          '회사는 회원이 이 약관의 규정을 위배하여 서비스 이용요금을 면탈하는 행위를 한 경우 동 면탈한 금액의 2배에 해당하는 금액을 청구할 수 있습니다.',
      },
      {
        title: '제34조 (손해배상)',
        content:
          '① 회사가 고의 또는 과실로 회원에게 손해를 발생시킨 경우, 손해에 대하여 배상할 책임이 있습니다.\n② 회사는 회사의 명백한 귀책사유로 회원이 서비스를 이용하지 못하는 경우에는 회원이 그 사실을 회사에 통보하여 확인한 시점 (또는 그 전에 회사가 그 사실을 알았거나 알 수 있게 된 시점)부터 1시간 이상의 서비스제공 중지시간에 대하여 최근 3 개월 (3 개월 미만인 경우는 해당기간 적용) 의 1 일 평균요금을 24(시간) 로 나눈 수를 서비스 중지시간과 곱하여 산출한 금액의 3 배를 기준으로 하여 협의 후 배상합니다. 이 경우 단수가 1 시간 미만인 경우에는 1 시간으로 합니다.\n③ 회원이 본 약관을 위반하여 회사에 손해를 발생시킨 경우, 회원은 회사에 대하여 그 손해를 배상할 책임이 있습니다.\n회원은 스팸메일 전송 등 불법행위를 하거나 전기통신사업법 등 관련 법령을 준수하지 못해 발생하는 모든 민형사상의 책임을 부담합니다.',
      },
    ],
  },
  {
    title: '제7장 기타',
    sub: [
      {
        title: '제35조 (회원의 법적 지위승계)',
        content:
          '① 상속, 합병, 분할, 영업양수 등으로 회원의 법적 지위의 승계 사유가 발생한 때에는 그 사유가 발생한 날로부터 30일 이내에 사업자등록증사본(개인은 주민등록증사본)과 지위승계를 입증할 수 있는 관련서류를 첨부하여 회사가 지정한 절차에 따라 신청하여야 합니다.\n② 회원의 지위가 승계될 경우에는 기존의 미납된 서비스 이용 요금 납입 의무도 승계되는 것으로 간주합니다.',
      },
      {
        title: '제36조 (책임제한)',
        content:
          '① 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 대한 책임이 면제됩니다.\n② 회사는 자신이 제공하지 않은 장비로 인한 서비스 장애에 따른 회원의 부가적, 영업적인 손해에 대해서는 책임을 지지 않습니다.\n③ 회사는 회원이 소프트웨어 라이선스 등과 같이 문제가 발생할 수 있는 소프트웨어를 임의 적용하여 유발되는 모든 법적인 문제에 대한 책임을 지지 않습니다.\n④ 회사에서 제공하는 백업서비스를 이용하지 않는 회원은 자체적으로 항상 백업을 하여야 하며, 이를 수행하지 않아 발생하는 피해에 대해서 회사는 어떠한 책임도 지지 않습니다.\n⑤ 회사는 전기통신사업법에 규정된 기간통신사업자 및 회원의 귀책사유로 인한 서비스 이용의 중지 또는 장애에 대하여는 책임을 지지 않습니다.\n⑥ 회사는 회원간 또는 회원과 제3자 상호간에 서비스를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다.\n⑦ 회사는 회원이 서비스 이용의 장애로 인하여 발생한 회원의 부가적, 영업적인 손해에 대해서는 책임을 지지 않습니다.\n⑧ 회사의 책임은 물리적인 서비스 사용에 한하며, 특히 회원이 게시 또는 전송하거나 전송 받은 자료의 내용 및 가치에 대해서는 책임을 지지 않습니다.',
      },
      {
        title: '제37조(정보의 수집)',
        content:
          '① 회사는 관련법령에 따라 회원이 전송한 메세지 정보 등을 일정기간 동안 저장•보관할 수 있습니다.\n② 전1항의 정보는 회원의 분쟁조정, 민원처리 등 필요한 경우 또는 법령이 정한 경우에 한하여 회사, 회사의 업무를 위임 받아 처리하는 자 또는 법령으로 권한을 부여 받은 자만이 열람하거나 활용할 수 있습니다.\n③ 회사는 본 정보를 열람할 경우 열람이 필요한 사유 및 열람 범위를 해당 회원에게 사전 고지합니다. 단, 중대한 약관 위반행위 또는 법령 위반행위와 관련하여 통신 내용을 열람할 경우 사후 고지합니다.',
      },
      {
        title: '제38조 (준거법 및 재판관할)',
        content:
          '① 회사와 회원 간 제기된 소송은 대한민국법을 준거법으로 합니다.\n② 회사와 회원 간 발생한 분쟁에 관한 소송은 민사소송법상의 관할법원에 제소합니다.',
      },
    ],
  },
  {
    title: '부칙',
    sub: [
      {
        title: '',
        content:
          '① 이 약관은 2016년 08월 12일부터 적용됩니다.\n' +
          '② 이 약관에 명시되지 않은 사항은 회사의 IDC 이용약관을 따릅니다.',
      },
    ],
  },
];
const cdn = [
  {
    title: '제1장 총 칙',
    sub: [
      {
        title: '제1조 (목적)',
        content:
          '본 약관은 ㈜디엔에이클라우드 (이하 “회사”)가 제공하는 CDN(Content Delivery Network) 서비스 관련 제반 서비스의 이용에 대하여 “회사”와 회원(본 약관에 동의하고 회원등록을 완료한 서비스 이용자를 의미합니다. 이하 “회원”)과의 권리•의무 및 기타 필요한 사항을 규정함을 목적으로 합니다.',
      },
      {
        title: '제2조 (용어의 정의)',
        content:
          '본 약관에서 사용하는 용어의 정의는 다음과 같습니다.\n1. “CDN 서비스”라 함은 회사가 회원의 컨텐츠를 보다 효율적으로 전송하기 위해 필요한 시스템과 네트워크 등 관련 설비를 제공하고 이를 관리하는 서비스를 의미합니다.\n2. “오리진 서버”라 함은 회사가 회원에게 CDN 서비스를 제공하기 위해 회원이 CDN서비스를 이용할 자신의 컨텐츠를 업로드하는 서버를 의미합니다.\n3. “트래픽”(파일 전송량)이라 함은 클라이언트 프로그램이 일정 시간 동안 서버로 데이터를 보내거나(Upload) 내려 받은(Download) 데이터를 의미하며, 단위로는 Mbyte, Gbyte 를 사용합니다.\n4. “대역”(Bandwidth)이라 함은 클라이언트 프로그램이 물리적인 회선을 이용할 때 데이터를 주고받기 위하여 실제로 점유하는 크기를 의미하며, 이의 측정은 사용한 트래픽 량을 일정 시간 단위로 이동 평균 그래프를 그리는 경우(Multi Router Traffic Grapher: MRTG) 의 폭으로 하며, 단위로는 Mbit/sec, Gbit/sec 를 사용합니다.\n5. “이용계약”이라 함은 회사가 제공하는 서비스 이용과 관련하여 회사와 이용자 간에 체결하는 계약을 의미합니다.\n6. “서비스 이용요금”이라 함은 본 서비스 계약을 수행하기 위하여 회원에게 청구하는 회사의 제반 서비스 비용으로, 계약되어진 정규성 경비와 추가적인 트래픽 이용료, 서버의 설치, 기술지원 등 계약서 내에 규정되어 있지는 않으나 쌍방 합의에 의하여 수행되어진 추가적인 서비스 업무에 대한 실비기준의 비정규성 경비를 의미합니다.\n7. “ID”(아이디)라 함은 회원의 식별과 서비스 이용을 위하여 회원이 정하고 회사가 승인하는 문자와 숫자의 조합을 의미합니다.\n8. “비밀번호”라 함은 회원이 부여 받은 ID와 일치하는 회원임을 확인하고 비밀보호를 위해 회원 자신이 정한 문자 또는 숫자의 조합을 의미합니다.',
      },
      {
        title: '제3조 (약관의 게시와 개정)',
        content:
          '1. 회사는 본 약관의 내용을 회원이 쉽게 알 수 있도록 서비스 초기 화면에 게시합니다.\n2. 회사는 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제에 관한 법률, 소비자기본법 등 관련법을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.\n3. 회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 기존약관과 함께 그 적용일자 7일 전부터 적용일자 전일까지 공지합니다. 다만, 회원에게 불리한 약관의 개정의 경우에는 시행일로부터 30일 전 서비스 홈페이지에 공지하거나 회원이 회원이용신청 시 등록한 e-mail로 전송하는 방법으로 회원에게 통지합니다.\n4. 회사가 전항에 따라 회원에게 개정약관을 공지 또는 통지하면서 회원에게 약관시행일까지 의사표시를 하지 않으면 승인한 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 개정약관에 동의한 것으로 봅니다.\n5. 회원이 개정약관의 적용에 동의하지 않는 경우 회사는 개정약관의 내용을 적용할 수 없으며, 이 경우 회원은 이용계약을 해지 할 수 있습니다.',
      },
    ],
  },
  {
    title: '제2장 이용계약 체결 및 관리',
    sub: [
      {
        title: '제4조 (이용계약 체결)',
        content:
          '1. 회사가 제공하는 서비스를 이용하고자 하는 자가 본 약관을 읽고 동의를 한 다음 회사가 제시하는 양식과 절차에 따라 이용신청을 한 내용에 대해 회사가 승낙함으로써 회사와 서비스 이용자 간 이용계약이 체결됩니다. 단, 이용신청에 별도의 자료제출이 요청되는 경우에는 예외로 합니다.\n2. 회사는 다음 각호에 해당하는 신청에 대해서는 승낙을 하지 않거나 사후에 이용계약을 해제 또는 해지 할 수 있습니다.\n① 허위의 정보를 기재하거나 허위서류를 첨부하여 이용신청을 하는 경우\n② 회사가 제시하는 회원 이용신청 절차를 완료하지 않거나 본인확인이 불가능한 경우\n③ 이용신청을 하고 회사가 별도로 규정하는 기간 내에 회사가 별도로 요구하는 자료제출을 하지 않는 경우\n④ 회사의 서비스 제공을 저해하거나 타 회원의 서비스 이용에 지장을 줄 것으로 예상되는 경우\n⑤ 제3자의 신용카드, 유/무선 전화, 은행 계좌 등을 무단으로 이용 또는 도용하여 서비스 이용요금을 결제하는 경우\n⑥ 회사로부터 계약해지를 당한 이후 1년이 경과하지 않은 경우\n⑦ 관련법령 등을 기준으로 하여 명백하게 사회질서 및 미풍양속에 반하는 위법행위를 할 목적으로 이용신청을 하는 경우\n⑧ 기타 회원의 자격을 부여하기에 곤란한 사유가 있는 경우\n3. 회사는 다음 각호에 해당하는 신청에 대해서는 승낙을 지연할 수 있습니다.\n① 회사의 설비에 여유가 없거나 기술적 장애가 있는 경우\n② 서비스 상의 장애 또는 서비스 이용요금 결제수단의 장애가 발생한 경우\n③ 기타 회사가 재정적, 기술적으로 필요하다고 인정하는 경우',
      },
      {
        title: '제5조 (회원의 ID등의 관리 의무)',
        content:
          '1. 회원은 서비스 이용을 위한 ID 및 비밀번호의 관리에 대한 책임, 본인 ID의 제3자에 의한 부정사용 등 회원의 고의•과실로 인해 발생하는 모든 불이익에 대한 책임을 부담합니다.\n2. 회원은 ID, 비밀번호 등을 도난 당하거나 제3자가 사용하고 있음을 인지한 경우에는 즉시 비밀번호를 수정하는 등의 조치를 취하여야 하며, 이를 회사에 통보하여 회사의 안내를 따라야 합니다.',
      },
      {
        title: '제6조 (회원정보의 변경)',
        content:
          '회원은 이용신청 시 기재한 사항이 변경되었을 경우 홈페이지 기재의 전화 및 e-mail로 회원정보의 수정을 요청하여야 하며, 변경하지 않음으로써 발생한 불이익에 대하여 회사는 책임을 지지 않습니다.',
      },
      {
        title: '제7조 (개인정보 수집)',
        content:
          '1. 회사는 적법하고 공정한 수단에 의하여 이용계약의 성립 및 이행에 필요한 최소한의 개인정보를 수집합니다.\n2. 회사는 개인정보의 수집 시 관련법규에 따라 개인정보취급방침에 그 수집범위 및 목적을 사전 고지합니다.',
      },
      {
        title: '제8조 (개인정보보호의무)',
        content:
          '회사는 정보통신망법 등 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및 회사의 개인정보처리방침이 적용됩니다.',
      },
      {
        title: '제9조 (불만처리)',
        content:
          '1. 회사는 개인정보와 관련하여 회원의 의견을 수렴하고 불만을 처리하기 위한 절차를 마련하여야 합니다.\n2. 회사는 전화, 전자우편 등을 통하여 회원의 불만사항을 접수, 처리 하여야 합니다.',
      },
      {
        title: '제10조 (회사의 의무)',
        content:
          '1. 회사는 관련법과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 서비스를 제공하기 위하여 노력합니다.\n2. 회사는 서비스 운영에 지장이 되는 장애가 발생했을 경우 이를 즉시 수리 또는 복구해야 하며, 안정적인 서비스 운영을 위해 최선을 다해야 합니다. 단, 오리진 서버의 장애로 인해 오리진 서버의 데이터가 손실된 경우에 대해서는 책임을 지지 않습니다.\n3. 회사는 회원의 개인정보보호를 위하여 보안시스템을 갖추어야 하며 개인정보처리방침을 공시하고 준수합니다.\n4. 회사는 회원이 스팸메일 전송 등 불법행위를 한 사실을 확인한 경우, 한국인터넷진흥원, 경찰청 등 관계기관에 관련 자료를 첨부하여 신고할 수 있습니다.\n5. 회사는 회원 중 고정 IP를 사용하는 개인 및 관리자 정보를 한국인터넷진흥원 등 인터넷주소관리기관에 최소한의 범위 내에서 제공할 수 있습니다.\n6. 회사는 회원으로부터 제기되는 의견이나 불만이 정당하다고 인정되는 경우에는 이를 즉시 처리합니다. 회원이 이용신청 시 기입한 전화나 e-mail로 처리과정 및 결과를 통보할 수 있습니다.',
      },
      {
        title: '제11조 (회원의 의무)',
        content:
          '1. 회원은 회사가 정한 서비스 이용요금을 지정된 일자에 납입할 의무가 있습니다.\n2. 회원은 회사가 제공하는 서비스를 이용함에 있어 다음 각 호에 해당하는 행위를 하여서는 안됩니다.\n① 이용신청이나 변경 시 타인의 정보 또는 허위내용을 등록하는 행위\n② 다른 회원의 ID 및 비밀번호를 도용하는 행위\n③ 회사 및 타인의 명예를 손상시키거나 업무를 방해하는 행위\n④ 스팸메일을 전송하는 행위\n⑤ 다음 각목에 해당하는 정보 또는 컨텐츠를 전송, 도달, 유포하는 행위\n 가) 음란한 부호, 문언, 음향, 화상 또는 영상을 배포, 판매, 임대하거나 공연히 전시하는 내용의 정보\n 나) 사람을 비방할 목적으로 공연히 사실 또는 허위의 사실을 적시하여 타인의 명예를 훼손하는 내용의 정보\n 다) 공포심이나 불안감을 유발하는 부호, 문언, 음향, 화상 또는 영상을 반복적으로 상대방에게 도달하게 하는 내용의 정보\n 라) 정당한 사유 없이 정보통신시스템, 데이터 또는 프로그램 등을 훼손, 멸실, 변경, 위조하거나 그 운용을 방해하는 내용의 정보\n 마) 청소년보호법에 따른 청소년 유해 매체물로서 상대방의 연령 확인, 표시의무 등 법령에 따른 의무를 이행하지 아니하고 영리를 목적으로 제공하는 내용의 정보\n 바) 법령에 따라 금지되는 사행행위에 해당하는 내용의 정보\n 사) 법령에 따라 분류된 비밀 등 국가기밀을 누설하는 내용의 정보\n 아) 국가보안법에서 금지하는 행위를 수행하는 내용의 정보\n 자) 그 밖에 범죄를 목적으로 하거나 교사 또는 방조하는 내용의 정보\n 차) 타인의 지적재산권 또는 초상권 등 타인의 권리를 침해하는 내용의 정보\n 카) 기타 법령에 저촉되는 내용의 정보\n3. 회원은 회사의 CDN 서비스를 이용하여 제공되는 데이터의 저작권 및 유해성 등에 대하여 모든 법적책임을 부담해야 합니다.\n4. 회원은 자신이 운영 중인 서버가 인가 받지 않은 침입자로부터 안전하게 보호받을 수 있도록 시스템 운영과 관련한 정기적인 보안 업데이트를 하여야 하며, 별도로 시스템 보안 서비스와 관련한 계약을 회사와 체결한 경우를 제외하고는 발생한 보안 사고에 대하여 회사는 책임을 지지 아니합니다.\n5. 회원은 자신이 운영 중인 서비스의 데이터 등에 대해 별도로 저장할 의무가 있으며 외부 침입 등으로 인한 정보의 유출, 누락 또는 자료의 손실에 대해 회사는 책임을 지지 않습니다.\n6. 회원은 회사로부터 제공받은 설비, 계정 및 소프트웨어 등을 망실 또는 훼손하거나 장애를 초래한 경우에는 그 보충, 수선 또는 기타 공사에 소요되는 비용을 부담하여야 합니다.\n7. 회원은 CDN 서비스를 이용하기 위해 회사로부터 오리진 서버를 제공받은 경우, 오리진 서버에 등재된 데이터 등에 대해 별도로 저장할 의무가 있으며, 회사의 오리진 서버 장애로 인한 데이터 소실시 회원은 즉시 소실된 데이터를 복구해야 합니다.\n8. 회원은 관련법 및 본 약관의 규정을 비롯하여 회사가 통지하는 사항 등을 준수하여야 합니다.',
      },
    ],
  },
  {
    title: '제3장 서비스의 이용',
    sub: [
      {
        title: '제12조 (서비스의 이용개시)',
        content:
          '1. 회사는 회원이 이용신청서에 기재한 서비스 개통 희망일에 맞추어 서비스를 개통합니다. 다만, 회사의 업무일정과 서버 등의 장비 및 설비 현황에 따라 서비스 개통 예정일이 변경될 수 있습니다. 2. 회사는 업무상 또는 기술상의 장애로 인하여 서비스를 개시하지 못하는 경우에는 회원에게 이를 통지합니다. 3. 회원은 서비스 개통 예정일을 변경 또는 연기 하고자 하는 경우 개통 예정일로부터 최소 3일 전 회사에 통지하여야 하며, 변경 또는 연기된 개통 예정일이 최초 개통 예정일로부터 3일을 초과하는 경우, 회사는 자신의 판단으로 회원과 최초 협의한 장비 설치장소를 변경할 수 있습니다.',
      },
      {
        title: '제13조 (서버환경 지원 및 서비스 이전)',
        content:
          '1. 회사는 회원이 정상적으로 서비스를 이용할 수 있도록 최적의 서버환경을 지원해야 하며, 회원이 특별한 서버환경을 요청하는 경우에는 별도로 합의하여야 합니다. 2. 회원이 서비스를 타사로 이전하는 경우 네임서버의 캐시(cache) 등으로 인하여 회사의 과실 없이 접속이 1~2일 정도 중단되더라도 이는 인터넷 환경의 특성이므로 회사는 이에 대한 책임을 지지 아니 합니다. 또한 이전과 관련하여 기존에 사용하는 파일의 이전과 권한 설정작업은 회원이 직접 하여야 합니다.',
      },
      {
        title: '제14조 (서비스의 제공)',
        content:
          '1. 회사는 회원에게 아래와 같은 서비스를 제공합니다. ① 캐싱(Caching) 서비스 ② 다운로드 (Download) 서비스 ③ 스트리밍 (Streming) 서비스 2. 제1항의 각 서비스 및 제휴 서비스의 내용은 변경 될 수 있으며, 이 경우 회사는 서비스 홈페이지에 공지하거나 회원이 이용신청 시 등록한 e-mail로 회원에게 통지 합니다. 3. 서비스는 연중무휴 1일 24시간 제공함을 원칙으로 합니다.',
      },
      {
        title: '제15조 (캐싱 서비스의 이용)',
        content:
          '1. 회원은 회사로부터 회원의 컨텐츠를 효과적으로 전송하기 위해 회사의 CDN 기반설비를 이용할 수 있으며, 매월 서비스 이용료를 납부해야 합니다. 2. 회원은 회사에서 제공하는 캐싱서비스의 구성에 맞추어 상호작업 (이하 “연동”이라 합니다.)을 수행합니다. 3. 회원은 연동 서비스 이용간 아래 각 호의 사항을 준수해야 합니다. ① 연동을 위해 회사는 회원에게 URL을 발급하며, 회원은 발급받은 URL을 통해 서비스를 이용합니다. ② 회원은 회사의 캐싱 서비스를 이용할 컨텐츠를 업로드 하기 위해 오리진 서버를 제공받을 수 있으며, 회사와 별도의 협의를 거치지 않는 경우 오리진 서버에 업로드하는 전체 데이터 용량은 10GB를 초과할 수 없습니다.',
      },
      {
        title: '제16조 (다운로드 서비스의 이용)',
        content:
          '1. 회원은 회사로부터 회원의 컨텐츠를 효과적으로 전송하기 위해 회사의 CDN 기반설비를 이용할 수 있으며, 매월 서비스 이용료를 납부해야 합니다. 2. 회사는 FTP 혹은 HTTP의 2가지 방식 중 회원이 원하는 방식으로 24시간 무중단 서비스를 제공합니다. 3. 회원은 회사에서 제공하는 다운로드 서비스의 구성에 맞추어 연동을 수행합니다. 4. 회원은 연동 서비스 이용간 아래 각 호의 사항을 준수해야 합니다. ① 연동을 위해 회사는 회원에게 URL을 발급하며, 회원은 발급받은 URL을 통해 서비스를 이용합니다. ② 회원은 회사의 다운로드 서비스를 이용할 컨텐츠를 업로드 하기 위해 오리진 서버를 제공받을 수 있으며, 회사와 별도의 협의를 거치지 않는 경우 오리진 서버에 업로드하는 전체 데이터 용량은 10GB를 초과할 수 없습니다. ③ 회원은 회사의 다운로드 서비스를 이용해 회원의 데이터를 배포하기 위해 회사에서 제공하는 전용 다운로드 프로그램을 제공받을 수 있습니다. ④ 회원이 회사에서 제공하는 전용 다운로드 프로그램을 사용하기 위해서는 회사에서 제공하는 전용 다운로드 프로그램의 규격에 맞추어 회원의 서비스를 제공해야 합니다.',
      },
      {
        title: '제17조 (스트리밍 서비스의 이용)',
        content:
          '1. 회원은 회사로부터 회원의 컨텐츠를 효과적으로 전송하기 위해 회사의 CDN 기반설비를 이용할 수 있으며, 매월 서비스 이용료를 납부해야 합니다. 2. 회사는 HTTP 혹은 RSTP 또는 WMS의 3가지 방식 중 회원이 원하는 방식으로 24시간 무중단 서비스를 제공합니다. 3. 회원은 회사에서 제공하는 스트리밍 서비스의 구성에 맞추어 연동을 수행합니다. 4. 회원은 연동 서비스 이용간 아래 각 호의 사항을 준수해야 합니다. ① 연동을 위해 회사는 회원에게 URL을 발급하며, 회원은 발급받은 URL을 통해 서비스를 이용합니다. ② 회원은 회사의 다운로드 서비스를 이용할 컨텐츠를 업로드 하기 위해 오리진 서버를 제공받을 수 있으며, 회사와 별도의 협의를 거치지 않는 경우 오리진 서버에 업로드하는 전체 데이터 용량은 10GB를 초과할 수 없습니다.',
      },
      {
        title: '제18조 (트래픽 제한)',
        content:
          '1. 회사는 회원이 실제로 이용하는 인바운드 트래픽(회원의 접속 포트가 수신하는 트래픽)이 이용계약 체결 시 선택한 인터넷접속서비스 총 용량의 10%를 초과할 경우 사전 통보 후, 인터넷접속을 제한할 수 있습니다. 2. 대한민국 이외의 국가를 대상으로 CDN 서비스를 이용하고자 하는 회원은 별도의 요금체계에 의한 국제 전용 서비스 계약을 체결하여야 합니다. 3. 회사는 국제 전용 서비스를 신청하지 않은 회원의 국제 트래픽 사용량이, 이용계약 체결 시 선택한 인터넷접속서비스 총 용량의 3%를 초과할 경우(3%를 초과하지 않는 경우라도 총 트래픽이 20M를 초과하는 경우) 사전 통보 후, 인터넷접속을 제한할 수 있습니다.',
      },
    ],
  },
  {
    title: '제4장 서비스의 제한',
    sub: [
      {
        title: '제19조 (서비스의 중단)',
        content:
          '1. 회사는 회원에게 안정된 서비스를 제공하기 위하여 24시간 365일 전체 CDN 서비스 설비를 점검하여야 하며 이를 위하여 정기적, 비정기적 운영점검을 실시합니다. 그 내용은 다음 각 호와 같습니다.\n① 정기적 운영점검: 회사는 전체 CDN 서비스 설비의 이상 유무를 점검하고, 전송효율을 높이기 위하여 주기별로 해당 점검일 오전 05시～07시 사이에 정기적 운영점검을 실시하며, 관련 내용을 사전에 회원에게 통보합니다.\n② 비정기적 운영점검: 회사는 CDN 서비스의 효율을 높이거나, 불특정 원인으로 인하여 오동작을 발생시키는 경우 문제점을 해결하기 위하여 비정기적 운영점검을 실시할 수 있습니다.\n2. 회사는 전항의 사유로 인해 점검간 서비스 중단이 불가결한 경우, 서비스 중단하기 이전에 회원의 계약서에 명시된 기술담당자에게 점검 관련 내용을 통보를 하도록 합니다.\n3. 회사가 ①항에 의거, 점검내용을 공지 또는 통지하게 되면, 회원이 점검 전까지 명시적으로 거부 의사표시를 하지 아니한 경우 회원은 점검에 동의한 것으로 봅니다.\n4. 회사가 ①항에 의거, 회원에게 서비스 중단 작업에 대한 통지를 하였을 경우 회원은 특별한 사유가 없는 한 작업을 승인해야 합니다.',
      },
      {
        title: '제20조 (서비스의 제한)',
        content:
          '1. 회사는 다음 각 호의 경우 1개월 이내의 기간을 정하여 회원의 서비스 이용을 제한하거나 중지시킬 수 있습니다.\n① 회원이 회사 서비스의 운영을 고의•과실로 방해하는 경우\n② 회원이 제11조 및 본 약관상의 의무를 위반하는 경우\n③ 회원이 스팸메일을 전송하거나 바이러스 유포, 기타 네트워크 장애를 유발하는 행위를 한 경우\n④ 스팸릴레이로 이용되거나 웜에 감염되어 스팸메일을 전송한 경우\n⑤ 서비스를 범죄에 이용한다고 객관적으로 판단되는 경우\n⑥ 회원 서버가 이용계약 체결에 따른 네트워크 대역을 초과하여 사용하는 경우\n⑦ 회원 서버가 해킹되었거나, 바이러스에 감염된 것으로 의심되는 경우\n⑧ 회원 서버가 과다한 전기를 사용하거나 발열로 인하여 회사의 서비스 운영에 지장이 발생될 것으로 예상되는 경우\n⑨ 과도한 국제 회선 사용으로 인하여 기간통신사업자로부터 이의 해소를 요구 받은 경우\n⑩ 정부 기관이 증거 자료 확보를 이유로 적절한 법적 절차를 거쳐 운영 서버에 대한 일시적인 서비스 중지를 요청한 경우\n⑪ 방송통신위원회, 미래창조과학부 또는 한국인터넷진흥원 등 관련 기관이 스팸메일 등 불법행위의 전송 사실을 확인하여 이용정지를 요청하는 경우\n⑫ 회원이 회사의 허락 없이 기본 포트(telnet, FTP, web 등) 이외 다른 포트(시스템에서 각각의 서비스를 구분하기 위해 사용되는 번호)를 점유하는 임의의 데몬(시스템에서 대기하면서 사용자의 요청에 대해 미리 지정된 규칙에 따라 응답 및 통신하기 위해 사용되는 프로그램)을 사용한 경우\n2. 회원은 이용정지 시작일로부터 1개월 이내에 그 사유를 해소하여야 하며, 회사는 이용정지의 사유가 해소되면 즉시 서비스의 이용을 가능하게 합니다.\n3. 회사는 12개월 이상 서비스를 이용하지 아니하는 이용자의 개인정보를 보호하기 위해 서비스 이용 계약을 해지하거나 개인정보의 파기 등 필요한 조치를 할 수 있습니다.\n4. 회사는 휴면 계정 기간 만료 30일 전까지 개인정보가 파기되거나 분리되어 저장되는 사실과 기간 만료일 및 해당 개인정보의 항목을 전자우편, 서면, 모사전송, 전화 또는 유사한 방법 중 하나의 방법으로 이용자게 알리도록 합니다.\n5. 제3항에 따른 서비스 이용 계약의 해지의 삭제에 대한 책임은 회원이 부담하며, 회사는 고의 또는 과실이 없는 한 데이터 삭제에 따른 책임을 부담하지 않습니다.',
      },
      {
        title: '제21조 (손해배상)',
        content:
          '1. 회사가 고의 또는 과실로 회원에게 손해를 발생시킨 경우, 손해에 대하여 배상할 책임이 있습니다.\n2. 회사는 회사의 명백한 귀책사유로 이용고객이 서비스를 이용하지 못하는 경우에는 이용고객이 그 사실을 회사에 통보하여 확인한 시점 (또는 그 전에 회사가 그 사실을 알았거나 알 수 있게 된 시점)부터 1시간 이상의 서비스제공 중지시간에 대하여 최근 3 개월 (3 개월 미만인 경우는 해당기간 적용) 의 1 일 평균요금을 24(시간) 로 나눈 수를 서비스 중지시간과 곱하여 산출한 금액의 3 배를 기준으로 하여 협의 후 배상합니다. 이 경우 단수가 1 시간 미만인 경우에는 1 시간으로 합니다.\n3. 회사의 오리진서버의 장애로 오리진 서버에 보관된 회원의 데이터가 소실된 경우 회사는 오리진 서버의 복구를 제공하며, 오리진 서버에 보관된 회원의 데이터의 복구에 대해서는 책임을 지지 아니합니다.\n4. 회원이 본 약관을 위반하여 회사에 손해를 발생시킨 경우, 회원은 회사에 대하여 그 손해를 배상할 책임이 있습니다.\n5. 회원은 스팸메일 전송 등 불법행위를 하거나 전기통신사업법 등 관련 법령을 준수하지 못해 발생하는 모든 민형사상의 책임을 부담합니다.',
      },
    ],
  },
  {
    title: '부칙',
    sub: [
      {
        title: '',
        content:
          '1. 이 약관은 2016년 08월 12일부터 적용됩니다. \n' +
          '2. 이 약관에 명시되지 않은 사항은 회사의 IDC 이용약관을 따릅니다.',
      },
    ],
  },
];
const cloud = [
  {
    title: '제 1 조 (목적)',
    content:
      '본 약관의 목적은 “고객사”와 Amazon Web Services Inc.,(이하 “AWS”라 한다)의 공식 파트너인 “디엔에이클라우드”간의 AWS 서비스 (“AWS”에서 제공하는 서비스를 총칭한다)에 약관관계에서 발생하는 권리와 의무, 그 밖에 필요한 기본적인 사항을 규정함을 목적으로 한다.',
  },
  {
    title: '제 2 조 (용어의 정의)',
    content:
      '1.“디엔에이 클라우드 서비스”는 디엔에이클라우드가 고객사에 제공하는 컨설팅, 구축, 운영, 서포트 및 빌링 서비스의 전체 또는 일부 서비스를 의미한다.\n2.“구축”은 디엔에이클라우드가 고객사의 상황에 맞게 가이드 및 아키텍쳐를 제공하고 시스템을 셋팅하는 것을 의미한다.\n3.“운영”은 고객사가 사용하는 “디엔에이 클라우드 서비스”에 대해 모니터링, 정기업무 및 수시로 발생하는 기술적인 사항에 대해 디엔에이클라우드에서 문제해결을 지원하는 것을 의미한다.\n4.“서포트”는 고객사가 “디엔에이 클라우드 서비스”의 사용에 있어 발생하는 각종 사항에 대해 디엔에이클라우드에서 가이드와 해결 방안을 제시하는 것을 의미한다.\n5.“빌링”은 “디엔에이 클라우드 서비스”의 과금 체계 및 청구에 관한 전반 사항을 의미한다.\n6.“고객사”는 AWS의 계정과 디엔에이클라우드의 계정을 연동하여, 디엔에이클라우드에서 제공하는 서비스를 사용하고 디엔에이클라우드를 통하여 비용을 납부하는 것에 관한 전반 사항을 의미한다.\n7.가상계정은 디엔에이클라우드에서 서비스 목적으로 직접 가입하고 관리되는 AWS 계정이다\n8.클라우드머니는 디엔에이클라우드의 클라우드 상품을 결제하는데 사용되는 선불식 충전금이다.',
  },
  {
    title: '제 3 조 (고객사의 서비스 이용 약관)',
    content:
      '고객사는 “AWS”의 “표준이용약관” (http://aws.amazon.com/ko/agreement/) 및 “AWS”의 “서비스 약관” (http://aws.amazon.com/service-terms/) 을 기본으로 본 약관서에 준하여 “디엔에이 클라우드 서비스”를 이용하며, 고객사는 “표준이용약관”에 따라 서비스에 접근하고 이를 사용할 수 있다. “AWS 표준이용약관”에 의해 서비스 레벨 (이하 “SLA”, Service Level Agreement)이 규정된 경우, “SLA”의 적용을 받는다.\n\n1.고객사는 “표준이용약관”에 정의된 서비스 약관, 이용방침 및 모든 기타 제반 방침들을 포함한 모든 법령 및 규칙을 준수한다.\n2.고객사가 디엔에이클라우드의 “운영” 또는 “서포트” 서비스를 사용할 경우, 고객사는 Amazon CloudWatch 접근 및 조회 권한을 디엔에이클라우드에 제공하며, 이를 위해 Access Key, Secret Key 및 IAM User Account 를 제공한다.',
  },
  {
    title: '제 4 조 (디엔에이클라우드의 서비스 제공 사항)',
    content:
      '“디엔에이 클라우드 서비스”는 약관일로부터 발효되며, 디엔에이클라우드가 본 약관에 따라 고객사에게 제공하는 서비스 범위는 아래와 같다.\n\n1.“디엔에이 클라우드 서비스”의 업무 범위는 고객사와 합의된 업무 범위 내에서 컨설팅, 구축, 운영, 서포트, 빌링 서비스 및 고객사와 합의된 3rd party 솔루션을 전체 또는 일부 제공한다.\n2.디엔에이클라우드는 서비스 종류, 서비스 내용, 가격 및 기타 서비스 관련 사항을 회사의 홈페이지에 게시하며, 고객은 게시된 내용을 기준으로 서비스 이용신청을 해야 한다.',
  },
  {
    title: '제 5 조 (지식 재산권의 귀속 및 침해 금지)',
    content:
      '디엔에이클라우드가 제공하는 지적 저작물에 대한 저작권 및 기타 지식 재산권은 디엔에이클라우드에 귀속되며, 고객사는 디엔에이클라우드의 지식 재산권을 침해하여서는 안 된다.',
  },
  {
    title: '제 6 조 (의무)',
    content:
      '1.디엔에이클라우드는 계약의 이행 중에 취득하게 된 일체의 영업비밀 및 기타 제반 기술사항 등을 본 계약기간 및 본 계약 종료 후에도 제 3 자에게 누설하거나 타 목적에 사용할 수 없으며, 이를 위반할 경우 책임을 부담하여야 한다.\n2.디엔에이클라우드는 서비스 이용과 관련하여 이용자로부터 제기된 의견이나 불만이 정당하다고 인정되는 경우에는 그 문제를 신속하게 해결하며, 신속한 처리가 곤란한 경우에는 그 사유와 처리일정을 고객사에게 통지하여야 한다.\n고객사는 이용계약에 정해진 기일 또는 시간까지 요금을 납입하여야 하고, 요금을 청구할 주소, 연락처, 전자우편 등 변경사항 발생 시 이를 회사에 지체 없이 알려야 하며, 이를 이행하지 않아 발생한 불이익은 이용자의 책임으로 한다.\n3.고객사는 서비스를 이용하여 디엔에이클라우드의 다른 고객 또는 제 3 자에게 손해를 가하는 경우에 회사는 손해의 방지를 위하여 주의의무를 다한 경우에는 이에 대한 책임을 지지 않는다.\n4.고객사는 아이디와 비밀번호 등 서비스에 접속하기 위한 정보에 대하여 관리책임이 있으며, 도용 또는 제 3 자의 이용으로 인해 발생한 문제의 책임은 이용자에게 있다. 다만, 회사에 고의 또는 과실이 있는 경우에는 그렇지 아니한다.\n5.고객사는 이 계약의 규정, 이용안내 및 서비스와 관련하여 회사로부터 통지 받은 제반사항을 확인하고 준수하여야 한다.\n6.고객사는 다음 각 호의 행위를 하여서는 안 된다.\n가.이용신청 또는 변경 시 허위 내용의 기재\n나.타인의 정보 도용\n다.이용계약의 범위를 넘는 영업행위\n라.회사 또는 회사의 대리인으로 오인하게 하는 행위\n마.불법 정보(컴퓨터 프로그램 등 포함)의 송신 또는 게시\n바.회사 또는 제 3 자의 저작권 등 지적재산권에 대한 침해\n사.회사 또는 제 3 자의 명예를 훼손하거나 업무를 방해하는 행위\n아.악성 프로그램의 배포 또는 시스템의 취약점을 악용하는 등 부정한 방법으로 서비스를 이용하는 행위\n자.그 밖에 관련 법령에서 금지하거나 사회질서에 반하는 행위',
  },
  {
    title: '제 7 조 (약관 해지)',
    content:
      '양 당사자는 다음의 각 호에 하나에 해당하는 사유가 발생하는 경우 상대방에 대하여 해지 의사를 30일 전에 서면 통지함으로써 이 약관의 전부 또는 일부를 해지할 수 있다.\n\n1.고객사가 약관 해지를 원할 경우 해지 일로부터 30일 전에 디엔에이클라우드에게 서면 통보해야 하며, 고객사가 원하는 해지 일자를 기준으로 미지불 이용 요금이 발행한 경우 지불을 완료해야 해지 절차가 완료 된다.\n2.디엔에이클라우드가 약관 해지를 원할 경우, 고객사에 해지 일로부터 30일 전에 서면 통보하고 고객사의 “디엔에이 클라우드 서비스” 약관을 해지 할 수 있다.\n3.디엔에이클라우드는 고객사가 파산신청, 압류, 가압류, 부도, 경매, 회사정리 등의 사항에 해당하는 경우 즉시 약관을 해지할 수 있다.',
  },
  {
    title: '제 8 조 (대금 및 결제)',
    content:
      '1.“디엔에이 클라우드 서비스” 서비스 이용료는 고객사의 서비스 이용 금액으로 “디엔에이 클라우드 서비스” 사용내역에 따라 정해진다.\n2.디엔에이클라우드는 매일 월초부터 2일 전까지 예상된 사용요금을 업데이트하며, 업데이트된 사용금액이 충전된 클라우드머니의 50% 초과시점부터 등록된 메일과 휴대전로 안내메일 또는 SMS로 주기적으로 사용량 또는 충전요청 내용을 발송한다.\n3.디엔에이클라우드는 10일 이전 전월에 이용한 요금을 확정한 후 클라우드머니에서 차감되며, “디엔에이 클라우드 서비스” 이용내역서를 요금담당자 메일로 발송한다.\n4.서비스 이용료의 납부는 원화(한화)를 기준으로 하며, 환율은 “디엔에이 클라우드 서비스”를 사용한 매월 첫번째 영업일 기준 “국민은행 최초 고시된 전신환매도율”을 기준으로 한다.\n5.디엔에이클라우드는 이용내역서 발송 후 이의가 없을 경우 클라우드머니 금액, 즉 디엔에이 클라우드 서비스 사용금액을 기준으로 세금계산서를 발송한다.\n6.클라우드머니 충전은 다음 각 호의 모든 사항과 같다.\n가.클라우드머니는 고객사가 신용카드와 현금(이하 “현금 등”)을 통해 충전할 수 있다.\n나.클라우드머니 와 “현금 등”의 교환비율은 1:1 이다.\n다.클라우드머니 최소 충전금액은 1,000원부터 충전할 수 있다.\n라.클라우드머니 충전 방법은 디엔에이클라우드 운영 정책에 따라 예고없이 변경될 수 있다.\n마.고객사가 회원을 자진탈퇴 할 경우, 예치금 보유잔액은 본 약관 제 8조 7항(환불) 조항에 따라 환불 받으실 수 있으며, 환불 받지 않고 회원탈퇴를 하실 경우 개인정보취급방침에 명시한 대금 결제 및 재화 등의 공급에 관한 개인정보의 보관기간이 경과한 이후에는 자동 소멸한다.\n7.클라우드머니 환불은 다음 각 호의 사항과 같다.\n가.사용되지 않은 클라우드머니의 환불을 원하는 고객사는 디엔에이클라우드의 고객센터를 통하여 환불 신청이유를 통지하고 직접 환불신청을 하여야 한다.\n나.클라우드머니 환불 시 재정경제부에서 고시한 "인터넷이용관련소비자피해보상"상 규정한 위약금(위약금 존재 시 총 이용료의 10%) 및 PG수수료, 송금비용을 공제한 이용료 잔액을 환불된다.',
  },
  {
    title: '제 9 조 (서비스 이용요금 연체 관리 중지 및 삭제 조항 추가)',
    content:
      '1.고객사가 서비스 요금 납부일 경과 또는 클라우드 사용 예상요금이 클라우드머니를 초과 후에도 요금을 납부하지 않을 경우 디엔에이클라우드는 “디엔에이 클라우드 서비스” 이용을 제한할 수 있다.\n2.고객사가 서비스 중지나, 제한 통보를 수신한 후 10일 이후에 모든 서비스가 삭제 될 수 있으며, 시스템이나 데이터의 망실에 대하여는 책임을 지지 않는다.\n3.고객사는 이용요금 연체가 발생할 경우 연체 발생 10일 이내에 디엔에이클라우드에게 사유 및 입금 예정일을 즉시 알려야 하며, 정당한 사유 없이 연체한 고객사에 대하여 디엔에이클라우드는 법정이자를 가산하여 청구할 수 있다.',
  },
  {
    title: '제 10 조 (손해배상)',
    content:
      '1.본 약관을 위반한 당사자는 약관위반에 따라 상대방에게 발생한 모든 손해 (대외적인 명예∙이미지 손상을 포함한다)에 대한 배상책임을 부담한다.\n2.제7조에 의한 해지권의 행사는 제10조 1항의 손해배상의 청구에 영향을 미치지 아니한다.',
  },
  {
    title: '제 11 조 (권리 의무의 양도 등 금지)',
    content:
      '양 당사자는 상대방의 사전 서면 동의 없이 본 약관 상의 당사자 지위 또는 권리∙의무의 일부 또는 전부를 제3자에게 양도, 이전하거나 이를 담보로 제공하는 등 일체의 처분행위를 하여서는 아니 되며, 이를 위반할 경우 그에 대한 손해배상의 책임을 진다.',
  },
  {
    title: '제 12 조 (면책조항)',
    content:
      '1. 관련 법령의 개폐, 천재지변, 전쟁, 정부의 조치, 국제 분쟁, 기타 디엔에이클라우드의 통제범위를 벗어난 불가항력으로 인하여 계약을 이행하지 못한 경우 쌍방 모두가 그 책임을 부담하지 않으며, 쌍방합의에 의하여 계약 내용을 변경 또는 계약을 해지할 수 있다.\n2. 디엔에이클라우드는 고객사의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않는다.\n3. 고객사의 솔루션 또는 고객사의 개발 및 애플리케이션을 포함하여, AWS와 무관한 솔루션, 개발 및 애플리케이션과 관련한 문제는 디엔에이클라우드에서 기술지원의 책임을 지지 않는다.\n4. 디엔에이클라우드가 제공하는 서비스의 범위는 AWS 제공하는 서비스에 한하며, 디엔에이클라우드에서 제공한 서비스 또는 상품이 아닌 경우이거나 디엔에이클라우드에서 제공하지 아니한 서비스 또는 상품과 결합되어 있는 경우에 대해서 일체의 책임을 지지 않는다.\n5. 디엔에이클라우드는 고객사 측에서 임의로 설치한 AWS와 무관한 솔루션, 애플리케이션 등 기타 소프트웨어나 장치 등으로 인하여 서비스 이용의 장애가 발생한 경우 일체의 책임이 면제된다.\n6. 고객사에서 AWS Support플랜이상의 지원을 디엔에이클라우드나 AWS에게 요구할 수 없으며, 고객사가 구매한 AWS Support 플랜이외의 문제에 대해서 디엔에이클라우드는 면책된다.\n7. 디엔에이클라우드의 고객사에 대하여만 의무와 책임을 부담하며, 고객사와 제 3자와의 관계에서 예상되는 손해, 제 3자로부터의 어떠한 배상요청 등 일체의 특별손해에 대해서 디엔에이클라우드는 책임을 지지 않는다.\n8. 본 계약 체결 후 관련 법령의 개폐, 천재지변, 전쟁, 정부의 조치, 국제 분쟁, 기타 디엔에이클라우드의 통제범위를 벗어난 불가항력으로 인하여 계약을 이행하지 못한 경우 쌍방 모두가 그 책임을 부담하지 않으며, 쌍방합의에 의하여 계약 내용을 변경 또는 계약을 해지할 수 있다.',
  },
  {
    title: '제 13 조 (분쟁해결)',
    content:
      '본 약관에 대한 이견 발생시 당사자는 대화를 통해 해결을 모색하며, 대화를 통한 해결이 불가할 시 대한민국 법령에 따라 대한민국 법원(서울중앙지방법원)에서 분쟁을 해결한다.',
  },
  {
    title: '제 14 조 (완전합의)',
    content:
      '본 이용약관은 당사자들 사이에 완전하고 최종적인 합의로서, 본 약관에 다른 거래와 관련하여 당사자들 사이에 본 약관 체결 당시 또는 그 이전에 있었던 모든 서면 또는 구두의 합의, 약관, 양해, 진술 및 보증은 본 약관의 체결로 그 효력을 상실하고 본 약관으로 대체된다.',
  },
  {
    title: '제 15 조 (마케팅 활용 동의)',
    content:
      '고객사는 디엔에이클라우드에 레퍼런스로 공개할 수 있으며, 레퍼런스 공개 범위는 아래 각 호와 같이 제한한다.\n\n1. 홍보기사 및 보도자료\n2. 홈페이지 또는 홍보물에 고객사의 로고 이용\n3. 고객사의 기술 정보 및 비밀 유지 계약서에 해당하는 내용은 사용할 수 없다.',
  },
];
const ServicePolicy = ({ firstSectionRef }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const headerHeight = useContext(HeaderHeightContext);
  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const [selectCategory, setSelectCategory] = useState(0);
  return (
    <div className="privacy-container flex-row align-center justify-center">
      <div
        ref={firstSectionRef}
        className="grid flex-full pb-160"
        style={{ paddingTop: headerHeight }}
      >
        <div className="categoryWrap  flex-row ">
          <div
            onClick={() => {
              setSelectCategory(0);
            }}
            className={`categoryTab flex-row align-center justify-center py-16 px-16 ${selectCategory === 0 ? 'active' : ''}`}
          >
            <span>IDC 이용약관</span>
          </div>
          <div
            onClick={() => {
              setSelectCategory(1);
            }}
            className={`categoryTab flex-row align-center justify-center py-16 px-16 ${selectCategory === 1 ? 'active' : ''}`}
          >
            <span>모바일 서비스 이용약관</span>
          </div>
          <div
            onClick={() => {
              setSelectCategory(2);
            }}
            className={`categoryTab flex-row align-center justify-center py-16 px-16 ${selectCategory === 2 ? 'active' : ''}`}
          >
            <span>호스팅 이용약관</span>
          </div>
          <div
            onClick={() => {
              setSelectCategory(3);
            }}
            className={`categoryTab flex-row align-center justify-center py-16 px-16 ${selectCategory === 3 ? 'active' : ''}`}
          >
            <span>CDN 이용약관</span>
          </div>
          <div
            onClick={() => {
              setSelectCategory(4);
            }}
            className={`categoryTab flex-row align-center justify-center py-16 px-16 ${selectCategory === 4 ? 'active' : ''}`}
          >
            <span>클라우드 이용약관</span>
          </div>
        </div>
        {selectCategory === 0 && (
          <>
            <h1 className={'pb-64'}>IDC 이용약관</h1>
            <div className="accoList  flex-col">
              {idc.map((section, index) => (
                <div className="accordion" key={index}>
                  <button
                    className="accordion-header flex-row align-center justify-between px-16 py-32"
                    onClick={() => toggle(index)}
                  >
                    <span>{section.title}</span>{' '}
                    <span
                      className={`flex-row justify-center align-center iconWrap ${activeIndex === index ? 'open' : ''}`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="8"
                        viewBox="0 0 14 8"
                        fill="none"
                      >
                        <path
                          d="M1.0625 6.86621L7 1.0144L12.9375 6.86621"
                          stroke="#555555"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </button>
                  <div
                    className={`accordion-content ${activeIndex === index ? 'open' : ''}`}
                  >
                    {section.sub.map((item, i) => {
                      return (
                        <div className={'pb-24'}>
                          <div className={'pb-24'}>
                            <span>{item.title}</span>
                          </div>
                          <span>{item.content}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        {selectCategory === 1 && (
          <>
            <h1 className={'pb-64'}>모바일 서비스 이용약관</h1>
            <div className="accoList  flex-col">
              {mobService.map((section, index) => (
                <div className="accordion" key={index}>
                  <button
                    className="accordion-header flex-row align-center justify-between px-16 py-32"
                    onClick={() => toggle(index)}
                  >
                    <span>{section.title}</span>{' '}
                    <span
                      className={`flex-row justify-center align-center iconWrap ${activeIndex === index ? 'open' : ''}`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="8"
                        viewBox="0 0 14 8"
                        fill="none"
                      >
                        <path
                          d="M1.0625 6.86621L7 1.0144L12.9375 6.86621"
                          stroke="#555555"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </button>
                  <div
                    className={`accordion-content ${activeIndex === index ? 'open' : ''}`}
                  >
                    {section.sub.map((item, i) => {
                      return (
                        <div className={'pb-24'}>
                          <div className={'pb-24'}>
                            <span>{item.title}</span>
                          </div>
                          <span>{item.content}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        {selectCategory === 2 && (
          <>
            <h1 className={'pb-64'}>호스팅 이용약관</h1>
            <div className="accoList  flex-col">
              {hosting.map((section, index) => (
                <div className="accordion" key={index}>
                  <button
                    className="accordion-header flex-row align-center justify-between px-16 py-32"
                    onClick={() => toggle(index)}
                  >
                    <span>{section.title}</span>{' '}
                    <span
                      className={`flex-row justify-center align-center iconWrap ${activeIndex === index ? 'open' : ''}`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="8"
                        viewBox="0 0 14 8"
                        fill="none"
                      >
                        <path
                          d="M1.0625 6.86621L7 1.0144L12.9375 6.86621"
                          stroke="#555555"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </button>
                  <div
                    className={`accordion-content ${activeIndex === index ? 'open' : ''}`}
                  >
                    {section.sub.map((item, i) => {
                      return (
                        <div className={'pb-24'}>
                          <div className={'pb-24'}>
                            <span>{item.title}</span>
                          </div>
                          <span>{item.content}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        {selectCategory === 3 && (
          <>
            <h1 className={'pb-64'}>CDN 이용약관</h1>
            <div className="accoList  flex-col">
              {cdn.map((section, index) => (
                <div className="accordion" key={index}>
                  <button
                    className="accordion-header flex-row align-center justify-between px-16 py-32"
                    onClick={() => toggle(index)}
                  >
                    <span>{section.title}</span>{' '}
                    <span
                      className={`flex-row justify-center align-center iconWrap ${activeIndex === index ? 'open' : ''}`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="8"
                        viewBox="0 0 14 8"
                        fill="none"
                      >
                        <path
                          d="M1.0625 6.86621L7 1.0144L12.9375 6.86621"
                          stroke="#555555"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </button>
                  <div
                    className={`accordion-content ${activeIndex === index ? 'open' : ''}`}
                  >
                    {section.sub.map((item, i) => {
                      return (
                        <div className={'pb-24'}>
                          <div className={'pb-24'}>
                            <span>{item.title}</span>
                          </div>
                          <span>{item.content}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        {selectCategory === 4 && (
          <>
            <h1 className={'pb-64'}>클라우드 이용약관</h1>
            <div className="accoList  flex-col">
              {cloud.map((section, index) => (
                <div className="accordion" key={index}>
                  <button
                    className="accordion-header flex-row align-center justify-between px-16 py-32"
                    onClick={() => toggle(index)}
                  >
                    <span>{section.title}</span>{' '}
                    <span
                      className={`flex-row justify-center align-center iconWrap ${activeIndex === index ? 'open' : ''}`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="8"
                        viewBox="0 0 14 8"
                        fill="none"
                      >
                        <path
                          d="M1.0625 6.86621L7 1.0144L12.9375 6.86621"
                          stroke="#555555"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </button>
                  <div
                    className={`accordion-content ${activeIndex === index ? 'open' : ''}`}
                  >
                    <div className={'pb-24'}>{section.content}</div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ServicePolicy;
